import React from "react";
import _, { flatMap } from "lodash";
import {
  Input,
  Row,
  Col,
  Tabs,
  Radio,
  Typography,
  Drawer,
  Switch,
  message,
  Button,
  Space,
  Select,
  Collapse,
  Spin,
} from "antd";
import {
  SaveOutlined,
  CloseOutlined,
  EyeOutlined,
  BugOutlined,
  InsertRowBelowOutlined,
  UnorderedListOutlined,
  AppstoreOutlined,
  TableOutlined,
  BarChartOutlined,
  FileImageOutlined,
  CloseCircleOutlined,
  LoadingOutlined,
  PieChartOutlined,
  LineChartOutlined,
} from "@ant-design/icons";
import {
  AndroidFilled as AndroidFilledIcon,
  LogoutOutlined as LogoutIcon,
  UserOutlined as UserIcon,
  LeftOutlined as BackIcon,
} from "@ant-design/icons";

import SplitPane from "react-split-pane";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Responsive, WidthProvider } from "react-grid-layout";
import ResourceEditor from "./ResourceEditor";
import ReportWidjet from "./ReportWidjet";
import { DashboardLayout } from "ecologital-ui-library";
import {
  saveDashboardAsync,
  publishDashboardAsync,
  updateComponentPositions,
  addDashboardConfig,
  resetEditor,
  resetAllEditorData,
  resetBoardSavingState,
  resetBoardPublishState,
  updateSelectedWidjet,
  updateSelectedResourceWidgetName,
  updateSelectedResource,
  updateResourceProperties,
  resetResourceRemoveState,
  getDashboardDetailsAsync,
  resetResourceAddStatus,
  updateDashboardName,
  updateSelectedFields,
  reOrderFields,
  resetChartConfig,
  fetchAllResourceDataAsync,
  updateDrillDowns,
} from "../../redux/editorSlice";
import { getBoardsAsync } from "../../redux/boardSlice";
import "./editorStyles.css";
import { signout } from "../../redux/userSlice";
import MaterialDesignIcon from "../../components/common/MaterialDesignIcon";
import NoPermission from "../../components/common/NoPermission";
import ConfirmDialog from "../../components/common/ConfirmDialog";
import ResourceFilters from "./ResourceEditor/ResourceFilters";
import TrashIcon from "../../assets/icons/delete-icon.svg";
import ResetIcon from "../../assets/icons/reset-icon.svg";
import TickIcon from "../../assets/icons/tick-mark.svg";
import CloseIcon from "../../assets/icons/close-icon2.svg";
import EyeIcon from "../../assets/icons/eye.svg";
import SaveIcon from "../../assets/icons/save-disk.svg";
import PublishIcon from "../../assets/icons/send-icon.svg";
import RefreshIcon from "../../assets/icons/reset-icon.svg";
import FullscreenIcon from "../../assets/icons/fulls-screen.svg";
import DownloadIcon from "../../assets/icons/downlode.svg";
import { exportRowsToCsv, exportChartToCsv } from "../../utils/widgetExport";

const { Panel } = Collapse;
const ResponsiveReactGridLayout = WidthProvider(Responsive);
/* RGL's id for the temporary item it inserts while something is being dragged onto the
   canvas. It is RGL's own default and it emits layouts containing it, so both the
   dropping placeholder we hand it and the guard in onLayoutChange have to agree on it. */
const RGL_DROPPING_ITEM_ID = "__dropping-elem__";
const { Search } = Input;
const { TabPane } = Tabs;
const onSearch = (value) => console.log(value);
const { Paragraph } = Typography;

class ResizableHandles extends React.Component {
  static defaultProps = {
    className: "layout",
    rowHeight: 30,
    cols: { lg: 12, md: 6, sm: 6, xs: 4, xxs: 2 },
    /* ── KEEP THIS. THE CANVAS IS A FREE PLAYGROUND. ──
       verticalCompact: false OUT-RANKS compactType inside RGL (utils.compactType:
       `verticalCompact === false ? null : compactType`), and it reaches the grid through
       the {...this.props} spread in render, where nothing passes verticalCompact after it
       to undo it. That is deliberate here: it is what turns compaction OFF, so a widget
       stays exactly where it is dropped and the author can lay a dashboard out freely.
       The saved x/y is the whole point - it is what a published board is rebuilt from.

       It looks like a bug next to `compactType={this.state.compactType}` ("vertical")
       below, and it was removed once on that reading. Removing it packs every widget to
       the top: the drop placeholder snaps to the packed slot instead of following the
       pointer, and whatever you drop lands back in the same one spot. Do not remove it.

       The published views (Dashboard/ReportWidjets, ReportHtmlView/HtmlReportWidgets)
       leave it out on purpose and compact instead - they are rendering a finished layout,
       not building one, so packing out any gaps is right there and wrong here. */
    verticalCompact: false,
    preventCollision: true,
  };

  constructor(props) {
    super(props);

    this.state = {
      editorItems: [],
      currentBreakpoint: "lg",
      /* Vertical packing: items settle upward and make room for each other, so a
         second chart lands under the first instead of overlapping it. Horizontal left
         gaps that widgets fell into and looked glitchy. */
      compactType: "vertical",
      mounted: false,
      layouts: { lg: this.generateLayout() },
      newCounter: 0,
      activeKey: 2,
      styleClass: "parentgrid",
      splitPosition: 0.6 * window.innerHeight,
      selectedComponent: "",
      filters: true,
      fullscreen: false,
      refresh: false,
      autorefresh: false,
      refreshInterval: "5m",
      csvdownload: false,
      visible: false,
      value: "",
      layout: "",
      activeWidgetName: "table",
      rightSidebarTab: "properties",
      // ── DRILL DOWN ──
      // Saved config lives on the selected resource (per widget) - see getDrillDown().
      // drillDraft holds unsaved edits until Save is pressed; null means "show the saved one".
      drillDraft: null,
      isAddingMapping: false,
      // Reset wipes the whole drill-down, so it asks first
      isResetConfirmOpen: false,
      mappingDraft: { from: undefined, to: undefined },
      activeChartType: null,
      isFullScreen: false,
      /* True only between dragstart and dragend on a widget tile from the Insert panel.
         It exists to stop the canvas's own elements from stealing the dragover events -
         see the --dropping rules in editorStyles.css for why that matters. */
      isDroppingNewWidget: false,
    };
    this.onPreview = this.onPreview.bind(this);
  }

  componentDidMount() {
    /* The editor is a fixed 100vh frame whose three columns each scroll on their own,
       so a page-level scrollbar can only ever be a second, redundant one - and anything
       a pixel over 100vh (a banner, a modal's scroll lock, a rounded viewport height)
       is enough to produce it. The class is on <body> because that is the element that
       scrolls; it is removed on the way out so every other page keeps its own scroll. */
    document.body.classList.add("editor-page-open");

    this.props.getBoardsAsync();
    if (this.props.match.params.selectedId) {
      this.props.getDashboardDetailsAsync({ id: this.props.match.params.selectedId });
    }
    if (!this.props.dashboardConfig) {
      /* Corrupt or hand-edited localStorage threw here, in componentDidMount, before the
         editor had rendered anything. */
      try {
        const stored = localStorage.getItem("currentDashboardConfig");
        if (stored) this.props.setDashboardConfig(JSON.parse(stored));
      } catch (e) {
        console.error("currentDashboardConfig could not be read:", e);
      }
    }

    // keeps the button label in sync (incl. exiting with Escape) and re-measures the grid
    document.addEventListener("fullscreenchange", this.handleFullScreenChange);
    document.addEventListener("webkitfullscreenchange", this.handleFullScreenChange);

    // ensure the grid and charts measure correctly after navigation/mount
    [50, 250, 600].forEach((delay) => setTimeout(() => window.dispatchEvent(new Event("resize")), delay));
  }

  componentWillUnmount() {
    document.body.classList.remove("editor-page-open");
    this.props.resetAllEditorData();
    // the old code removed an inline arrow, which is a different reference - so the
    // listener was never actually detached
    document.removeEventListener("fullscreenchange", this.handleFullScreenChange);
    document.removeEventListener("webkitfullscreenchange", this.handleFullScreenChange);
  }

  /* react-grid-layout sizes its items from the container width it measured last.
     Entering or leaving fullscreen resizes that container, but the browser does not
     reliably fire a resize once the transition has finished - so the grid kept the
     previous width and the widgets rendered at half the screen. Nudging it a few times
     across the transition makes it re-measure. */
  handleFullScreenChange = () => {
    const isFullScreen = Boolean(document.fullscreenElement || document.webkitFullscreenElement);
    this.setState({ isFullScreen });
    [50, 250, 600].forEach((delay) => setTimeout(() => window.dispatchEvent(new Event("resize")), delay));
  };

  changeReslutIds = () => {
    let maxValue = 0;
    this.props.resourceList?.forEach((resource) => {
      maxValue = Number(resource?.layout?.i) > maxValue ? Number(resource?.layout?.i) : maxValue;
    });

    const resource = this.props.resourceList
      .map((resource, index) => {
        if (resource?.layout?.i) {
          return {
            i: resource.layout.i,
            x: resource.layout.x,
            y: resource.layout.y,
            w: resource.layout.w,
            h: resource.layout.h,
            component: resource.charts && Boolean(Object.values(resource.charts).length) ? "chart" : "table",
            reportData: resource && resource.reportData ? resource.reportData : [],
            resourceId: resource && resource.id ? resource.id : null,
            source: resource,
          };
        }
      })
      .filter((resource) => resource);
    /* ── WHICH TILE THE INSERT TAB SHOWS AS SELECTED ──────────────────────────
       activeWidgetName starts life as "table" (see the constructor) and was only ever
       moved off it by onBoxClick - clicking a widget on the canvas. Opening a board
       for editing never touched it, so the Insert tab highlighted Table on every
       report that had just been opened, including a donut chart's, and the right-hand
       panels followed it.

       The type is saved on the resource, so read it from the board that just loaded:
       the selected widget on a dashboard, the only one on a report. */
    const current =
      this.props.resourceList.find((rl) => rl.id === this.props.selectedResource?.id) || this.props.resourceList[0];
    const chartType = current?.charts?.chartType || null;

    if (resource.length) {
      this.setState(
        {
          layouts: { lg: resource },
          newCounter: Number(maxValue) + 1,
          activeWidgetName: chartType ? "chart" : "table",
          activeChartType: chartType,
        },
        () => {
          [50, 250, 600].forEach((delay) => setTimeout(() => window.dispatchEvent(new Event("resize")), delay));
        },
      );
    }
  };

  componentDidUpdate(prevProps, prevState) {
    /* Rebuild the canvas from the board that just loaded.
       changeReslutIds() turns each resource's saved `layout` back into a grid item, but
       it was only ever called after a resource was DELETED - nothing ran it when a board
       was opened for editing, so the widgets were in state and the canvas was empty until
       you dragged them on again. */
    if (prevProps.isLoadingDashboard && !this.props.isLoadingDashboard) {
      this.changeReslutIds();
    }

    // drop the drill-down draft when the user switches widget, so the panel
    // always shows the newly selected widget's saved config
    if (prevProps.selectedResource?.id !== this.props.selectedResource?.id && this.state.drillDraft) {
      this.setState({ drillDraft: null, isAddingMapping: false });
    }

    if (this.props.boardSavingState && this.props.boardSavingState.status) {
      if (this.props.boardSavingState.status === "SUCCESS") {
        message.success("Board successfully saved!");
        this.props.resetBoardSavingState();
      } else if (this.props.boardSavingState.status === "ERROR") {
        message.error("Oops, Board has not been saved!");
        this.props.resetBoardSavingState();
      } else if (this.props.boardSavingState.status === "BadRequest") {
        message.error("Bad Request. Check your Configurations or sign in again to the reporting app");
        this.props.resetBoardSavingState();
      }
    }

    if (this.props.boardPublishState && this.props.boardPublishState.status) {
      if (this.props.boardPublishState.status === "SUCCESS") {
        /* Guarded so it runs once. resetBoardPublishState is a dispatch, so the status is
           still SUCCESS on the render that follows - which showed the toast a second time
           and queued a second redirect. */
        if (!this.publishHandled) {
          this.publishHandled = true;
          message.success("Board successfully published!");
          this.props.resetBoardPublishState();
          /* Publishing finishes the job, so leave the editor. The toast lives outside the
             route, so it stays on screen over the list. */
          this.returnToList();
        }
      } else if (
        this.props.boardPublishState.status === "ERROR" ||
        this.props.boardPublishState.status === "BadRequest"
      ) {
        message.error("Oops, Board has not been publish!");
        this.props.resetBoardPublishState();
      }
    }

    if (this.props.lastDeletedResourceID && this.props.lastDeletedResourceID !== prevProps.lastDeletedResourceID) {
      let layoutData = [...this.state.layouts.lg];
      /* Match the widget by the resource it renders. This filtered on the item's POSITION
         (`li + 1`), which only lined up while ids happened to equal positions - with
         several resources it removed the wrong widget, or none. */
      let layoutDataArr = layoutData.filter((d) => d.resourceId !== this.props.lastDeletedResourceID);
      this.setState({
        layouts: {
          lg: layoutDataArr.map((da, dIndex) => {
            return { ...da, id: dIndex + 1 };
          }),
        },
      });
      this.props.resetResourceRemoveState();
      this.changeReslutIds();
    }

    if (JSON.stringify(this.props.properties) !== JSON.stringify(prevProps.properties)) {
      this.setState({
        filters: this.props.properties.filters,
        fullscreen: this.props.properties.fullscreen,
        refresh: this.props.properties.refresh,
        autorefresh: this.props.properties.autorefresh,
        refreshInterval: this.props.properties.refreshInterval || "5m",
        csvdownload: this.props.properties.csvdownload,
      });
    }

    if (!Boolean(prevProps?.resourceList?.length) && this.props.resourceList !== prevProps.resourceList) {
      let maxValue = 0;
      this.props.resourceList?.forEach((resource) => {
        maxValue = Number(resource?.layout?.i) > maxValue ? Number(resource?.layout?.i) : maxValue;
      });
      const resource = this.props.resourceList
        .map((resource) => {
          if (resource?.layout?.i) {
            return {
              i: resource.layout.i,
              x: resource.layout.x,
              y: resource.layout.y,
              w: resource.layout.w,
              h: resource.layout.h,
              component: resource.charts && Boolean(Object.values(resource.charts).length) ? "chart" : "table",
              reportData: resource && resource.reportData ? resource.reportData : [],
              resourceId: resource && resource.id ? resource.id : null,
              source: resource,
            };
          }
        })
        .filter((resource) => resource);
      if (resource.length) {
        this.setState({
          layouts: { lg: resource },
          newCounter: maxValue + 1,
        });
      }
    }
  }

  // static defaultProps = {
  //   className: "layout",
  //   rowHeight: 30,
  //   cols: { lg: 12, md: 6, sm: 6, xs: 4, xxs: 2 },
  //   verticalCompact: false,
  //   preventCollision: true,
  // };

  /* ── DRILL DOWN ──
     Config is PER WIDGET, exactly as HyperLink was: it lives on the selected
     resource as drillDowns[], written through updateDrillDowns. That reducer
     mirrors it into resourceList, so saveDashboardAsync persists it and
     getDashboardDetailsAsync reads it back with no extra work.
     Only transient editing state (the mapping draft) stays in component state. */
  static DRILL_DOWN_DEFAULTS = {
    id: 1,
    enabled: false,
    allowAsTarget: false,
    triggerType: "row",
    navigationType: "_blank",
    targetType: "existing",
    reportId: undefined,
    serviceUrl: "",
    urlParamMap: {},
    /* One entry per link. Picking a column makes EVERY value in that column clickable -
       there is no cell value to match any more. `targetField` is the field in the target
       report that holds this column's value, i.e. a foreign key: clicking ID 1200 opens
       the target filtered to targetField = 1200.
       (The old per-cell `cells: [{ value, ... }]` shape is still read at runtime for
       boards already saved with it - see ReportGrid.getCellDrillDownRule.) */
    cellColumns: [
      { id: 1, column: undefined, actionType: "report", reportId: undefined, targetField: undefined, serviceUrl: "" },
    ],
    mappings: [],
    // legacy keys kept in sync so already-published boards keep working
    openningOption: "_blank",
    linkedItemKey: undefined,
    parameterKeys: [],
  };

  // the panel edits a draft; Apply commits it to the widget, Reset wipes it
  getDrillDown = () => {
    if (this.state.drillDraft) return this.state.drillDraft;
    const saved = this.props.selectedResource?.drillDowns?.[0];
    return { ...ResizableHandles.DRILL_DOWN_DEFAULTS, ...(saved || {}) };
  };

  patchDrillDown = (patch) => {
    this.setState({ drillDraft: { ...this.getDrillDown(), ...patch } });
  };

  /* ── APPLIED vs DRAFT ──
     Three layers, and only the first two live here:
       draft     - this.state.drillDraft, the unsaved panel edits
       applied   - selectedResource.drillDowns, what the canvas draws
       persisted - the board on the server, written ONLY by Save/Publish
     Apply and Reset both stop at `applied`. That is what makes a Reset survivable:
     leave without saving (or refresh, or navigate away) and componentDidMount refetches
     the board, so the drill-down the report was opened with comes back. */

  // does this widget currently have a drill-down applied
  hasAppliedDrillDown = () => Boolean(this.props.selectedResource?.drillDowns?.length);

  // both sides filled out the same way, so a config saved before a field existed does
  // not read as an edit
  drillDownBaseline = (dd) => this.withLegacyKeys({ ...ResizableHandles.DRILL_DOWN_DEFAULTS, ...(dd || {}) });

  /* "Dirty" means the draft genuinely differs from what is applied - not merely that
     the panel was touched. Touching a switch and putting it back left a draft object
     behind, so the button claimed there were changes to cancel when there were none. */
  isDrillDownDirty = () => {
    if (!this.state.drillDraft) return false;
    return !_.isEqual(
      this.drillDownBaseline(this.state.drillDraft),
      this.drillDownBaseline(this.props.selectedResource?.drillDowns?.[0]),
    );
  };

  /* What the canvas should draw for a widget.
     While the panel has unsaved edits, the selected widget previews the DRAFT rather than
     the applied config. Without this, switching Target Type or Trigger Type left the
     table showing links built from the setup you had just moved away from - the panel
     said External Service while the ID column was still linked to a report.
     Reset clears the draft, so the applied config comes straight back. */
  getPreviewDrillDowns = (resource) => {
    const isSelected = resource?.id && resource.id === this.props.selectedResource?.id;
    if (isSelected && this.state.drillDraft) {
      return [this.withLegacyKeys(this.state.drillDraft)];
    }
    return resource?.drillDowns || null;
  };

  /* Switching the trigger clears the other one's setup.
     Row Click and Cell Click keep their configuration in different places - Row Click on
     the drill-down itself, Cell Click inside cellColumns - so leaving the old one behind
     means saving a config for a trigger that is no longer selected, and reading it back
     shows fields the user thought they had replaced. */
  setTriggerType = (triggerType) => {
    const defaults = ResizableHandles.DRILL_DOWN_DEFAULTS;
    if (triggerType === "row") {
      this.patchDrillDown({
        triggerType,
        cellColumns: defaults.cellColumns.map((c) => ({ ...c })),
      });
      return;
    }
    this.patchDrillDown({
      triggerType,
      targetType: defaults.targetType,
      reportId: undefined,
      serviceUrl: "",
      urlParamMap: {},
      mappings: [],
    });
  };

  /* Same rule one level down: a Row Click target is either a report or a URL, never
     both, so the fields of the one being left are dropped. */
  setTargetType = (targetType) => {
    this.patchDrillDown(
      targetType === "external"
        ? { targetType, reportId: undefined, mappings: [] }
        : { targetType, serviceUrl: "", urlParamMap: {} },
    );
  };

  // and per Cell Click entry, which carries its own target
  setCellActionType = (columnId, actionType) => {
    this.updateCellColumn(
      columnId,
      actionType === "external"
        ? { actionType, reportId: undefined, targetField: undefined }
        : { actionType, serviceUrl: "", urlParamMap: {} },
    );
  };

  // fills the legacy keys from the new ones so existing renderers light up the column
  withLegacyKeys = (dd) => {
    const firstColumn = dd.cellColumns?.[0];
    // `cells` only exists on boards saved with the old per-cell shape
    const firstCell = firstColumn?.cells?.[0];

    // Old renderers can only make a COLUMN clickable - they have no row-click support.
    // For a row trigger we point them at the first mapped column so they still open the
    // right target from a cell, instead of leaving a stale column or nothing at all.
    const legacyColumn =
      dd.triggerType === "cell" ? firstColumn?.column : dd.mappings?.find((m) => m.from)?.from || firstColumn?.column;

    return {
      ...dd,
      openningOption: dd.navigationType === "_self" ? "_self" : "_blank",
      linkedItemKey: legacyColumn,
      reportId:
        dd.targetType === "existing"
          ? dd.triggerType === "cell"
            ? firstColumn?.reportId || firstCell?.reportId || dd.reportId
            : dd.reportId
          : undefined,
      parameterKeys: (dd.mappings || []).map((m) => m.from).filter(Boolean),
    };
  };

  saveDrillDown = () => {
    const dd = this.getDrillDown();

    /* Applying with the switch off briefly doubled as "remove", back when Reset only
       reverted. Reset owns removal again, so there is one way to remove and Apply is
       purely for committing a configuration. */
    if (!dd.enabled) {
      message.warning("Turn on Enable Drill Down first");
      return;
    }
    if (dd.triggerType === "cell") {
      /* One link per entry: a column, a target, and - for a report target - the field in
         that report holding this column's value. Without that field there is nothing to
         filter the target report by. */
      for (const col of dd.cellColumns || []) {
        if (!col.column) {
          message.warning("Select the column to link");
          return;
        }
        if ((col.actionType || "report") === "external") {
          if (!col.serviceUrl?.trim()) {
            message.warning(`Enter the service URL for "${col.column}"`);
            return;
          }
          const unmapped = this.getUnmappedUrlParams(col.serviceUrl, col.urlParamMap);
          if (unmapped.length) {
            message.warning(`Map the parameter "${unmapped[0]}" in the URL for "${col.column}"`);
            return;
          }
          continue;
        }
        if (!col.reportId) {
          message.warning(`Select the report that "${col.column}" opens`);
          return;
        }
        if (!col.targetField) {
          message.warning(`Select the field in the target report that matches "${col.column}"`);
          return;
        }
      }
    } else if (dd.targetType === "existing") {
      if (!dd.reportId) {
        message.warning("Select the report to drill into");
        return;
      }
      /* A row has no column of its own, so without a mapping there is nothing to carry
         across and the target would open showing everything. */
      const completeMappings = (dd.mappings || []).filter((m) => m.from && m.to);
      if (!completeMappings.length) {
        message.warning("Add at least one column mapping so the target report can be filtered");
        return;
      }
    } else if (!dd.serviceUrl?.trim()) {
      message.warning("Enter the service URL");
      return;
    } else {
      /* An unmapped <name> would be left in the URL as-is and the other app would get a
         literal placeholder instead of a value. */
      const unmapped = this.getUnmappedUrlParams(dd.serviceUrl, dd.urlParamMap);
      if (unmapped.length) {
        message.warning(`Map the parameter "${unmapped[0]}" to a field`);
        return;
      }
    }

    this.props.saveDrillDowns([this.withLegacyKeys(dd)]);
    this.setState({ drillDraft: null });
    message.success("Drill down applied");
  };

  /* CANCEL - shown in place of Reset while there are unsaved edits.
     Throws the draft away; getDrillDown then falls through to the applied config and
     getPreviewDrillDowns puts the canvas back with it. Apply is a commit point, so this
     lands on the LAST APPLIED state, not on how the report looked when it was opened.
     That original is still reachable - leave without saving and reopen. */
  cancelDrillDownEdits = () => {
    this.setState({ drillDraft: null, isAddingMapping: false });
    message.info("Changes discarded");
  };

  /* RESET - shown when there is nothing to cancel. Wipes the drill-down for this widget:
     switch off, every field cleared, and the links gone from the table, because the
     canvas reads the same applied config.
     Editor state only. The board on the server is untouched until Save, so a reset made
     by mistake is undone by leaving without saving. */
  resetDrillDown = () => {
    this.props.saveDrillDowns([]);
    this.setState({ drillDraft: null, isAddingMapping: false });
    message.success("Drill down reset");
  };

  /* Apply + (Cancel | Reset). Which of the two shows follows one rule:
       dirty & applied  -> Cancel  discard edits, back to the applied config
       dirty & none     -> Reset   nothing to go back to, so clearing IS the reset
       clean & applied  -> Reset   wipe the drill-down for this widget
       clean & none     -> Reset, disabled - nothing to clear */
  renderDrillDownActions = () => {
    const isDirty = this.isDrillDownDirty();
    const hasApplied = this.hasAppliedDrillDown();
    const showCancel = isDirty && hasApplied;
    const resetDisabled = !isDirty && !hasApplied;

    return (
      <div className="properties-actions">
        {isDirty ? <div className="properties-unsaved">Unsaved changes</div> : null}
        <div className="nav-type-actions">
          <button className="nav-btn-apply" onClick={this.saveDrillDown}>
            <img src={TickIcon} alt="apply-icon" />
            Apply
          </button>

          {showCancel ? (
            <button className="nav-btn-reset" onClick={this.cancelDrillDownEdits}>
              <img src={CloseIcon} alt="cancel-icon" /> Cancel
            </button>
          ) : (
            /* No wrapper around the button: Popconfirm wrapped it in a span, which broke
               the flex sizing that keeps Apply and Reset the same width. */
            <button
              className="nav-btn-reset"
              disabled={resetDisabled}
              onClick={() => this.setState({ isResetConfirmOpen: true })}
            >
              <img src={ResetIcon} alt="reset-icon" /> Reset
            </button>
          )}
        </div>

        <ConfirmDialog
          open={this.state.isResetConfirmOpen}
          title="Reset the drill down?"
          message="Every setting for this widget is cleared. Nothing is written to the report until you press Save."
          confirmText="Confirm"
          cancelText="Cancel"
          onCancel={() => this.setState({ isResetConfirmOpen: false })}
          onConfirm={() => {
            this.setState({ isResetConfirmOpen: false });
            this.resetDrillDown();
          }}
        />
      </div>
    );
  };

  nextId = (list) => (list.length ? Math.max(...list.map((i) => i.id)) + 1 : 1);

  addCellColumn = () => {
    const { cellColumns } = this.getDrillDown();
    this.patchDrillDown({
      cellColumns: [
        ...cellColumns,
        {
          id: this.nextId(cellColumns),
          column: undefined,
          actionType: "report",
          reportId: undefined,
          targetField: undefined,
          serviceUrl: "",
        },
      ],
    });
  };

  removeCellColumn = (columnId) => {
    const { cellColumns } = this.getDrillDown();
    this.patchDrillDown({ cellColumns: cellColumns.filter((c) => c.id !== columnId) });
  };

  updateCellColumn = (columnId, patch) => {
    const { cellColumns } = this.getDrillDown();
    this.patchDrillDown({
      cellColumns: cellColumns.map((c) => {
        if (c.id !== columnId) return c;
        /* Editing an entry re-configures it, so any old per-cell value rules are dropped.
           Kept, they would win at runtime and the table would still link only the old
           matching cells while this panel says the whole column is linked. */
        const { cells, ...rest } = c;
        return { ...rest, ...patch };
      }),
    });
  };

  // multiple cells can sit under one column, each with its own action
  addCell = (columnId) => {
    const { cellColumns } = this.getDrillDown();
    this.patchDrillDown({
      cellColumns: cellColumns.map((c) =>
        c.id === columnId
          ? { ...c, cells: [...c.cells, { id: this.nextId(c.cells), value: "", actionType: "report" }] }
          : c,
      ),
    });
  };

  removeCell = (columnId, cellId) => {
    const { cellColumns } = this.getDrillDown();
    this.patchDrillDown({
      cellColumns: cellColumns.map((c) =>
        c.id === columnId ? { ...c, cells: c.cells.filter((cell) => cell.id !== cellId) } : c,
      ),
    });
  };

  updateCell = (columnId, cellId, patch) => {
    const { cellColumns } = this.getDrillDown();
    this.patchDrillDown({
      cellColumns: cellColumns.map((c) =>
        c.id === columnId
          ? { ...c, cells: c.cells.map((cell) => (cell.id === cellId ? { ...cell, ...patch } : cell)) }
          : c,
      ),
    });
  };

  /* ── DRILL DOWN : COLUMN MAPPING ──
     One mapping list per widget, shared by the Row Click and Cell Click branches.
     "+ Add Mapping" opens a draft row; on save it joins the list as "from → to". */
  startAddMapping = () => {
    this.setState({ isAddingMapping: true, mappingDraft: { from: undefined, to: "" } });
  };

  cancelAddMapping = () => {
    this.setState({ isAddingMapping: false, mappingDraft: { from: undefined, to: "" } });
  };

  updateMappingDraft = (patch) => {
    this.setState(({ mappingDraft }) => ({ mappingDraft: { ...mappingDraft, ...patch } }));
  };

  saveMapping = () => {
    const { from, to } = this.state.mappingDraft;
    if (!from || !to) {
      message.warning("Select both a source and a target column");
      return;
    }
    const { mappings } = this.getDrillDown();
    this.patchDrillDown({ mappings: [...mappings, { id: this.nextId(mappings), from, to }] });
    this.setState({ isAddingMapping: false, mappingDraft: { from: undefined, to: undefined } });
  };

  removeMapping = (mappingId) => {
    const { mappings } = this.getDrillDown();
    this.patchDrillDown({ mappings: mappings.filter((m) => m.id !== mappingId) });
  };

  /* ── DRILL DOWN : EXTERNAL SERVICE URL ──
     Scope confirmed by the team: build the URL and open it. Nothing is sent to the
     external service by us - no auth, no headers, no server-side call.
     Parameters are written as <invoiceNumber> (spec) or {invoiceNumber} (mockups);
     both are accepted so either style works.

     NOTE: the `g` flag matters. Without it (or if this is undefined) `new RegExp(...)`
     yields a regex that matches at index 0 forever, and the exec loop below never
     terminates - which is what froze the editor on the External Service option. */
  static URL_PARAM_PATTERN = /<([^<>\s/]+)>|\{([^{}\s/]+)\}/g;

  /* A widget can be dragged from anywhere on the card - header, padding, chart area -
     except the parts a user needs to click or select. Restricting the drag to the header
     made the canvas feel stiff; cancelling on these instead keeps table values
     selectable and pagination/controls clickable. */
  static DRAG_CANCEL =
    ".widget-card-close, .widget-card-title-input, .ant-table-body, .ant-pagination, .ant-select, .ant-dropdown, a, button, input, textarea, select";

  getUrlParams = (url = "") => {
    const found = [];
    let match;
    const pattern = new RegExp(ResizableHandles.URL_PARAM_PATTERN);
    while ((match = pattern.exec(url)) !== null) {
      const name = match[1] || match[2];
      if (name && !found.includes(name)) found.push(name);
    }
    return found;
  };

  // substitutes the mapped fields, using the first loaded row so the preview is real
  buildPreviewUrl = (serviceUrlArg, urlParamMapArg) => {
    const dd = this.getDrillDown();
    const serviceUrl = serviceUrlArg !== undefined ? serviceUrlArg : dd.serviceUrl;
    const urlParamMap = (urlParamMapArg !== undefined ? urlParamMapArg : dd.urlParamMap) || {};
    if (!serviceUrl) return "";
    const sampleRow = this.props.selectedResource?.reportData?.data?.[0] || {};
    return serviceUrl.replace(new RegExp(ResizableHandles.URL_PARAM_PATTERN), (whole, angle, curly) => {
      const paramName = angle || curly;
      const fieldName = urlParamMap[paramName];
      if (!fieldName) return whole;
      const value = sampleRow[fieldName];
      return value === undefined || value === null ? `<${fieldName}>` : encodeURIComponent(value);
    });
  };

  // <name>s written in the URL that have no field behind them yet
  getUnmappedUrlParams = (url, urlParamMap) => {
    const map = urlParamMap || {};
    return this.getUrlParams(url).filter((name) => !map[name]);
  };

  onChangeServiceUrl = (url) => {
    // drop mappings for parameters that no longer exist in the url
    const params = this.getUrlParams(url);
    const { urlParamMap } = this.getDrillDown();
    this.patchDrillDown({
      serviceUrl: url,
      urlParamMap: Object.fromEntries(Object.entries(urlParamMap).filter(([name]) => params.includes(name))),
    });
  };

  setUrlParamField = (paramName, fieldName) => {
    const { urlParamMap } = this.getDrillDown();
    this.patchDrillDown({ urlParamMap: { ...urlParamMap, [paramName]: fieldName } });
  };

  /* Cell Click keeps its own URL per entry, so it keeps its own parameter map too.
     Same two helpers as above, scoped to one cellColumns entry. */
  onChangeCellServiceUrl = (columnId, url) => {
    const { cellColumns } = this.getDrillDown();
    const entry = (cellColumns || []).find((c) => c.id === columnId) || {};
    const params = this.getUrlParams(url);
    this.updateCellColumn(columnId, {
      serviceUrl: url,
      urlParamMap: Object.fromEntries(Object.entries(entry.urlParamMap || {}).filter(([n]) => params.includes(n))),
    });
  };

  setCellUrlParamField = (columnId, paramName, fieldName) => {
    const { cellColumns } = this.getDrillDown();
    const entry = (cellColumns || []).find((c) => c.id === columnId) || {};
    this.updateCellColumn(columnId, { urlParamMap: { ...(entry.urlParamMap || {}), [paramName]: fieldName } });
  };

  /* The External Service card, shared by Row Click and Cell Click so both behave the
     same. The clicked column is NOT required to appear in the URL - parameters are
     mapped independently to any field of this report, hidden ones included, since a
     hidden id is a normal thing to pass to another app. */
  renderExternalConfig = ({ serviceUrl, urlParamMap, onChangeUrl, onSetParamField, placeholder }) => {
    const urlParams = this.getUrlParams(serviceUrl);
    const map = urlParamMap || {};

    return (
      <div className="cell-action-card cell-action-card--external">
        <div className="cell-action-card-title">External Service Configuration</div>

        <div className="drill-field-group">
          <span className="drill-field-label">
            Service URL <span className="drill-required">*</span>
          </span>
          <textarea
            className="external-url-input"
            placeholder={placeholder || "https://invoice.example.com/invoice/<invoiceNumber>/<orgId>"}
            rows={3}
            value={serviceUrl || ""}
            onChange={(e) => onChangeUrl(e.target.value)}
          />
        </div>

        {urlParams.length > 0 ? (
          <div className="drill-mapping-section">
            <span className="drill-field-label">
              Parameter Mapping <span className="drill-required">*</span>
            </span>
            <div className="url-param-list">
              {urlParams.map((paramName) => (
                <div className="url-param-row" key={`param_${paramName}`}>
                  <span className="url-param-name">{paramName}</span>
                  <span className="drill-mapping-arrow">&#8594;</span>
                  <Select
                    showSearch
                    className="drill-select url-param-select"
                    placeholder="Select field"
                    optionFilterProp="children"
                    dropdownMatchSelectWidth={false}
                    value={map[paramName]}
                    onChange={(val) => onSetParamField(paramName, val)}
                  >
                    {(this.props.selectedResource?.availableFields || []).map((af) => (
                      <Select.Option key={af.id ?? af.fieldName} value={af.fieldName}>
                        {af.fieldDisplayName || af.fieldName}
                      </Select.Option>
                    ))}
                  </Select>
                </div>
              ))}
            </div>
          </div>
        ) : null}

        <div className="external-info-box">
          <div className="external-info-icon">i</div>
          <div className="external-info-text">
            <p>
              Write parameters as <strong>&lt;name&gt;</strong> and map each one to a field of this report.
            </p>
            <p>The URL is only built and opened - nothing is sent to the external service.</p>
          </div>
        </div>

        <div className="drill-field-group">
          <span className="drill-field-label">Preview URL</span>
          {/* no placeholder here - a sample URL in a read-only box reads as a real
              result, and the box is empty only until a URL is entered above */}
          <textarea
            className="external-url-input external-url-preview"
            rows={2}
            readOnly
            value={this.buildPreviewUrl(serviceUrl, map)}
          />
        </div>
      </div>
    );
  };

  /* Drill-down targets are reports "under the selected application", so only boards
     sharing an app with the board being edited are offered. */
  getTargetReportOptions = () => {
    const currentApps = this.props.dashboardConfig?.appList || [];
    return (this.props.boardsData || []).filter((bd) => {
      if (bd.id === this.props.match?.params?.selectedId) return false; // don't drill into itself
      if (!currentApps.length) return true;
      const boardApps = bd.appList || [];
      return boardApps.some((appId) => currentApps.includes(appId));
    });
  };

  /* The fields of ONE target report, for picking the field that matches a column here.
     Read from the boards list, which already carries every board's availableFields, so
     no extra request is needed.

     Every field is offered, hidden ones included. Whether a column is shown in the target
     report has nothing to do with whether it can be matched on - the value is in the data
     either way, and a hidden key column is a normal thing to join on.

     Returns { fieldName, label } so the list can show the target's display name while
     still matching on the real data key. */
  getFieldsForReport = (reportId) => {
    if (!reportId) return [];
    const seen = new Set();
    const fields = [];
    (this.props.boardsData || [])
      .filter((bd) => bd.id === reportId)
      .flatMap((bd) => bd.resources || [])
      .flatMap((rs) => rs.availableFields || [])
      .filter((af) => af?.fieldName)
      .forEach((af) => {
        if (seen.has(af.fieldName)) return;
        seen.add(af.fieldName);
        fields.push({ fieldName: af.fieldName, label: af.fieldDisplayName || af.fieldName });
      });
    return fields;
  };

  getTargetFieldOptions = () => {
    const dd = this.getDrillDown();
    const reportIds = [
      dd.reportId,
      // `cells` only exists on boards saved with the old per-cell shape
      ...(dd.cellColumns || []).flatMap((col) => [col.reportId, ...(col.cells || []).map((cell) => cell.reportId)]),
    ].filter(Boolean);

    const fields = (this.props.boardsData || [])
      .filter((bd) => reportIds.includes(bd.id))
      .flatMap((bd) => bd.resources || [])
      .flatMap((rs) => rs.availableFields || [])
      .map((af) => af.fieldName)
      .filter(Boolean);

    return [...new Set(fields)];
  };

  /* Target configuration for a ROW CLICK. Mirrors a cell's action card, but there is no
     value to match on - a row cannot be singled out, so the action applies to every row. */
  renderTargetConfig = () => {
    const dd = this.getDrillDown();
    const urlParams = this.getUrlParams(dd.serviceUrl);

    return (
      <div className="drill-target-body">
        <div className="drill-field-group">
          <span className="drill-field-label">
            Target Type <span className="drill-required">*</span>
          </span>
          <Select
            className="drill-select"
            style={{ width: "100%" }}
            value={dd.targetType}
            onChange={(val) => this.setTargetType(val)}
          >
            <Select.Option value="existing">Target Report</Select.Option>
            <Select.Option value="external">External Service</Select.Option>
          </Select>
        </div>

        {dd.targetType === "external" ? (
          this.renderExternalConfig({
            serviceUrl: dd.serviceUrl,
            urlParamMap: dd.urlParamMap,
            onChangeUrl: this.onChangeServiceUrl,
            onSetParamField: this.setUrlParamField,
          })
        ) : (
          <div className="cell-action-card cell-action-card--report">
            <div className="cell-action-card-title">Target Report Configuration</div>

            <div className="drill-field-group">
              <span className="drill-field-label">
                Select Report <span className="drill-required">*</span>
              </span>
              <Select
                showSearch
                className="drill-select"
                style={{ width: "100%" }}
                placeholder="Select report..."
                optionFilterProp="children"
                value={dd.reportId}
                onChange={(val) =>
                  // the mapped fields belong to the report, so drop them when it changes
                  this.patchDrillDown({ reportId: val, mappings: [] })
                }
              >
                {this.getTargetReportOptions().map((bd) => (
                  <Select.Option key={bd.id} value={bd.id}>
                    {bd.name}
                  </Select.Option>
                ))}
              </Select>
            </div>

            {/* Sits inside the report card, next to the report it belongs to, rather
                than stranded at the bottom of the panel. */}
            {this.renderColumnMapping()}

            <div className="cell-action-info">
              <div className="external-info-icon">i</div>
              <span>
                {(dd.mappings || []).length
                  ? `Clicking a row opens this report where ${(dd.mappings || [])
                      .filter((m) => m.from && m.to)
                      .map((m) => `${m.to} equals that row's ${m.from}`)
                      .join(" and ")}.`
                  : "When a row is clicked, the system will open the above report with mapped values."}
              </span>
            </div>
          </div>
        )}
      </div>
    );
  };

  /* Row Click only - exactly one pair. A row has no column of its own, so this says
     "this report's column holds the value of that report's field" and the target is
     filtered on it. Two dropdowns that write straight into mappings[0]: with a single
     pair there is nothing to confirm, so there is no draft, no tick and no cancel.
     Cell Click does not use this - there the column is chosen at the top of the entry,
     so its match sits inline. */
  setRowMapping = (patch) => {
    const { mappings } = this.getDrillDown();
    const current = (mappings || [])[0] || { id: 1 };
    this.patchDrillDown({ mappings: [{ ...current, ...patch }] });
  };

  renderColumnMapping = () => {
    const { mappings, reportId } = this.getDrillDown();
    const mapping = (mappings || [])[0] || {};
    const columns = this.props.selectedResource?.availableFields || [];
    // only the chosen report's fields - the old version pooled every referenced report
    const targetFields = this.getFieldsForReport(reportId);

    return (
      <div className="drill-mapping-section">
        <span className="drill-field-label">
          Column Mapping <span className="drill-required">*</span>
        </span>
        <span className="cell-help-text">
          Match a column in this report to the field that holds it in the target report.
        </span>

        <div className="drill-mapping-pair">
          <Select
            showSearch
            className="drill-select"
            placeholder="This report"
            optionFilterProp="children"
            value={mapping.from}
            onChange={(val) => this.setRowMapping({ from: val })}
            dropdownMatchSelectWidth={false}
          >
            {columns.map((af) => (
              <Select.Option key={af.id ?? af.fieldName} value={af.fieldName}>
                {af.fieldDisplayName || af.fieldName}
              </Select.Option>
            ))}
          </Select>

          <span className="drill-mapping-arrow">&rarr;</span>

          <Select
            showSearch
            className="drill-select"
            placeholder="Target report"
            optionFilterProp="children"
            value={mapping.to}
            onChange={(val) => this.setRowMapping({ to: val })}
            disabled={!reportId}
            dropdownMatchSelectWidth={false}
            notFoundContent={reportId ? "This report has no saved columns" : "Pick a target report first"}
          >
            {targetFields.map((f) => (
              <Select.Option key={f.fieldName} value={f.fieldName}>
                {f.label}
              </Select.Option>
            ))}
          </Select>
        </div>
      </div>
    );
  };

  // fullscreens the widget/canvas section only, not the whole app
  canvasRef = React.createRef();

  handleFullScreen = () => {
    if (!this.state.isFullScreen) {
      const target = this.canvasRef.current || document.documentElement;
      const request = target.requestFullscreen || target.webkitRequestFullscreen || target.msRequestFullscreen;
      if (!request) {
        message.warning("Full screen is not supported in this browser");
        return;
      }
      // state and the grid re-measure are handled by handleFullScreenChange
      Promise.resolve(request.call(target)).catch((err) => console.error("Fullscreen error:", err));
    } else {
      const exit = document.exitFullscreen || document.webkitExitFullscreen || document.msExitFullscreen;
      Promise.resolve(exit.call(document)).catch((err) => console.error("Fullscreen error:", err));
    }
  };

  onLayoutChange = (layout) => {
    /* ── DO NOT PERSIST A LAYOUT THAT IS STILL MID-DRAG ──
       RGL splices its dropping placeholder into its own layout on the first dragover and
       emits it from componentDidUpdate (activeDrag is not set yet, so it does not skip
       the callback). Letting that through was most of what "the drop glitches" was:

         updateWidjetPositions always rebuilds resourceList (editorSlice
         updateComponentPositions copies the array and reassigns it), so connect sees a
         new resourceList and re-renders the whole editor - generateDOM rebuilds every
         card and every antd table / Apex chart on the canvas - while the pointer is
         still moving. RGL balances its placeholder against a dragEnter/dragLeave counter
         over the grid's children, and a re-render in the middle of that can drive the
         counter to zero while the pointer is still inside, so the placeholder vanished
         and came back on the next dragover.

       The placeholder is also not a real widget: updateComponentPositions falls back to
       layout[index] for a resource with no saved `i`, so the phantom item's geometry
       could be written onto a real resource.

       The layout that matters is emitted again once the drop settles and the placeholder
       has been removed, so nothing is lost by ignoring these. */
    if (layout.some((l) => l.i === RGL_DROPPING_ITEM_ID)) return;

    /* RGL re-emits an identical layout on several of its own state changes. Each one cost
       a redux write and a full re-render for no change at all. */
    if (_.isEqual(layout, this.state.layout)) return;

    this.setState({ layout: layout });
    // layout.map(function (j, key, list) {
    //   const pageData = {
    //     width: j.w,
    //     height: j.h,
    //     x: j.x,
    //     y: j.y,
    //   }
    // })
    this.props.updateWidjetPositions(layout);
  };

  async onPreview() {
    await this.setState({
      visible: true,
    });
  }

  /* Label for a resource wherever it needs naming outside its own card - falls back to
     the source name, then to a positional label, so a widget is never listed as blank. */
  widgetLabelFor = (resource, index) =>
    resource?.source?.widgetName || resource?.source?.name || resource?.sources?.[0]?.name || `Widget ${index + 1}`;

  /* The per-widget half of Display Properties, dashboards only.
     Download and full screen act on one widget's data, so on a board with several
     widgets they have to be set per widget - a single board-wide switch could not say
     which table the download button belonged to. Refresh and auto refresh are absent on
     purpose: both reload the page, so they are board-level regardless. */
  renderWidgetDisplayProps = () => {
    if (this.isSingleWidgetBoard()) return null;

    const resources = this.props.resourceList || [];

    return (
      <div className="widget-prop-section">
        <div className="prop-level-label">Widgets</div>

        {resources.length === 0 ? (
          <p className="widget-prop-empty">Add a resource to set its display properties.</p>
        ) : (
          resources.map((resource, index) => {
            const properties = resource?.properties || {};
            return (
              <div className="widget-prop-card" key={`widget_props_${resource.id}`}>
                <div className="widget-prop-name" title={this.widgetLabelFor(resource, index)}>
                  {this.widgetLabelFor(resource, index)}
                </div>

                <div className="prop-toggle-list">
                  <div className="display-prop-row">
                    <Switch
                      checked={Boolean(properties.csvdownload)}
                      onChange={(checked) =>
                        this.props.setResourceProperty({ id: resource.id, key: "csvdownload", value: checked })
                      }
                    />
                    <span>Allow csv download</span>
                  </div>

                  <div className="display-prop-row">
                    <Switch
                      checked={Boolean(properties.fullscreen)}
                      onChange={(checked) =>
                        this.props.setResourceProperty({ id: resource.id, key: "fullscreen", value: checked })
                      }
                    />
                    <span>Display full screen button</span>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>
    );
  };

  /* The widget's title.
     A dashboard holds several widgets, so each one is named - click the title to rename
     it. A report holds one widget, and the thing that identifies it is the report itself,
     so it shows the report name and is not editable here; renaming happens in the Name
     field in the toolbar. The ERP shows the same, for the same reason. */
  /* Which widget the config panels are pointed at. Dashboards only: a report holds a
     single widget, so there is nothing to choose between. */
  renderActiveResourceLabel = () => {
    if (this.isSingleWidgetBoard()) return null;

    const selected = this.props.selectedResource;
    if (!selected?.id)
      return <span className="active-resource-label active-resource-label--none">No widget selected</span>;

    /* "Untitled" until the user names it, matching the widget card on the canvas.
       Falling back to the resource name made an unnamed widget look named, and two
       widgets built from the same resource then carried the same label. */
    const name = selected.source?.widgetName || "Untitled";
    return <span className="active-resource-label">{name}</span>;
  };

  renderWidgetTitle = (el, resource) => {
    /* Reports no longer render a title bar at all (see generateDOM), so this branch is
       only still here in case that bar comes back - it is what the report used to show. */
    if (this.isSingleWidgetBoard()) {
      return <span className="widget-card-title">{this.props.dashboardConfig?.boardName || "Untitled"}</span>;
    }

    const widgetName = resource?.source?.widgetName || "";
    if (this.state.editingWidgetId === el.i) {
      return (
        <input
          className="widget-card-title-input"
          autoFocus
          value={widgetName}
          placeholder="Widget name"
          onChange={(e) => this.props.updateWidgetName({ id: el.resourceId, widgetName: e.target.value })}
          onBlur={() => this.setState({ editingWidgetId: null })}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === "Escape") this.setState({ editingWidgetId: null });
          }}
          // a click here must not start a drag or bubble to the card
          onClick={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
        />
      );
    }

    return (
      <span
        className="widget-card-title widget-card-title--editable"
        title="Click to rename"
        onClick={(e) => {
          e.stopPropagation();
          this.setState({ editingWidgetId: el.i });
        }}
        onMouseDown={(e) => e.stopPropagation()}
      >
        {widgetName || "Untitled"}
      </span>
    );
  };

  generateDOM(el) {
    // ── extract once, use everywhere — avoids 20+ duplicate finds ──
    const resource = this.props.resourceList?.find((rl) => rl.id === el.resourceId);

    const resourceCharts = resource?.charts;
    const hasCharts = resourceCharts && resourceCharts.chartType && resourceCharts.fieldName;

    return (
      <div key={el.i} data-grid={el} onClick={this.onBoxClick.bind(this, el)}>
        {/* On a dashboard the panels edit one widget at a time, so which one has to be
            visible. A report has a single widget - nothing to distinguish. */}
        <div
          className={
            !this.isSingleWidgetBoard() && resource && resource.id === this.props.selectedResource?.id
              ? "widget-card widget-card--active"
              : "widget-card"
          }
        >
          {/* ── HEADER ──
              Dashboards only. A report holds one widget and the report's own name is
              already in the Name field in the toolbar (and on the view page's header), so
              the bar could only print that name a second time - it is not even editable
              here. Removing the widget still has to be possible, so on a report the close
              button floats in the card's corner instead of sitting in a bar. */}
          {this.isSingleWidgetBoard() ? (
            <button
              className="widget-card-close widget-card-close--floating"
              title="Remove this widget"
              onClick={(e) => {
                e.stopPropagation();
                this.onPutItem(el);
              }}
              onMouseDown={(e) => e.stopPropagation()}
            >
              ×
            </button>
          ) : (
            <div className="widget-card-header">
              {this.renderWidgetTitle(el, resource)}
              <button
                className="widget-card-close"
                onClick={(e) => {
                  e.stopPropagation();
                  this.onPutItem(el);
                }}
              >
                ×
              </button>
            </div>
          )}

          {/* ── BODY ── */}
          <div className="widget-card-body">
            <ReportWidjet
              widjetName={el.component}
              reportData={resource?.reportData || null}
              groupedReportData={resource?.groupedReportData || null}
              selectedWidgetName={resource?.source?.widgetName || ""}
              availableFields={resource?.availableFields || null}
              allFields={resource?.allFields || null}
              dataFilters={resource?.dataFilters || null}
              aggregation={resource?.aggregation || null}
              aggRowBuilders={resource?.aggRowBuilders || null}
              aggGroupBuilders={resource?.aggGroupBuilders || null}
              charts={hasCharts ? resourceCharts : el.charts || null}
              activeWidgetName={resource?.reportData ? resource?.widjet : null}
              selectedResourceId={el.resourceId}
              applyFilters={resource?.applyFilters || false}
              drillDowns={resource?.reportData ? this.getPreviewDrillDowns(resource) : null}
            />
          </div>
        </div>
      </div>
    );
  }

  /* Clicking a widget makes its resource the one every panel edits.
     
     This used to only set activeKey, so on a dashboard the Columns, Filters, Builder,
     Grouping and Drill Down panels all kept editing whichever resource happened to be
     selected last - usually the most recently added one. With two tables from two
     resources on a canvas, configuring the second one silently rewrote the first.
     
     A report holds a single widget, so there is nothing to disambiguate there; the
     dispatch is harmless but does no work. */
  onBoxClick = (el) => {
    this.setState({ activeKey: 1 }); // <- set key sent by the handler to the state

    const resource = (this.props.resourceList || []).find((rl) => rl.id === el.resourceId);
    if (!resource || resource.id === this.props.selectedResource?.id) return;

    this.props.selectResource(resource);

    /* The right panel shows Chart config for a chart and Grouping for a table, so the
       active widget type has to follow the selection too. */
    const widgetType = el.component === "chart" || resource?.charts?.chartType ? "chart" : "table";
    this.setState({
      activeWidgetName: widgetType,
      activeChartType: widgetType === "chart" ? resource?.charts?.chartType || this.state.activeChartType : null,
    });
  };

  handleChange = (selectedkey) => {
    this.setState({ activeKey: selectedkey }); // <- set key sent by the handler to the state
    // console.log(selectedkey);
  };

  onCompactTypeChange = () => {
    const { compactType: oldCompactType } = this.state;
    const compactType =
      oldCompactType === "horizontal" ? "vertical" : oldCompactType === "vertical" ? null : "horizontal";
    this.setState({ compactType });
  };

  onDrop = (layout, layoutItem, _event) => {
    /* A widget renders from resourceList.find(r => r.id === el.resourceId). Dropping
       without a selected resource produced an item with resourceId null - a permanently
       blank card that could not be filled in, which is the "added but nothing there"
       case. Refuse the drop instead and say why. */
    if (!this.props.selectedResource?.id) {
      message.warning("Select a resource first, then drag the widget onto the canvas");
      return;
    }

    if (!this.canAddWidget()) {
      message.warning("A report holds one widget. Remove the current one to add a different widget.");
      return;
    }

    // functional form: two quick drops read the same stale counter otherwise
    this.setState((prevState) => ({
      layouts: {
        lg: prevState.layouts.lg.concat({
          i: prevState.newCounter.toString(),
          /* Guarded: dashboardConfig is null when the editor is opened directly rather
             than through Create (a bookmark, or a refresh after storage was cleared), and
             dropping a widget then crashed on .boardType. */
          x: this.props.dashboardConfig?.boardType === "reports" ? 0 : layoutItem.x,
          y: this.props.dashboardConfig?.boardType === "reports" ? 0 : layoutItem.y,
          w: this.props.dashboardConfig?.boardType === "reports" ? 12 : 8,
          // h is in 30px rows + 10px margins, so 11 rows ~= the 430px the card used to be
          h: this.props.dashboardConfig?.boardType === "reports" ? 12 : 11,
          // component: this.state.components,
          component: this.state.activeWidgetName,
          chartType: this.state.activeChartType,
          reportData:
            this.props.selectedResource && this.props.selectedResource.reportData
              ? this.props.selectedResource.reportData
              : [],
          resourceId:
            this.props.selectedResource && this.props.selectedResource.id ? this.props.selectedResource.id : null,
          // source: this.props.selectedResource,
          source: {
            ...this.props.selectedResource,
            charts: {}, // always drop with empty charts so no stale config
          },
        }),
      },
      newCounter: prevState.newCounter + 1,
    }));
  };

  onToggle(selection, val) {
    this.setState({
      [selection]: val,
    });
    // window.location.href = "/editor/preview"
  }

  onClose = () => {
    this.setState({
      visible: false,
    });
  };

  onPutItem = (item) => {
    /* Deleting a chart widget clears that resource's chart config too. It used to stay
       behind, so dropping a new chart on the same resource rendered the deleted one
       instead of "Chart not configured". */
    if (item?.component === "chart" && item?.resourceId) {
      this.props.resetChartConfigForResource({ id: item.resourceId });
    }

    this.setState((prevState) => {
      return {
        layouts: {
          ...prevState.layouts,
          [prevState.currentBreakpoint]: prevState.layouts[prevState.currentBreakpoint].filter(({ i }) => i !== item.i),
        },
      };
    });
  };

  onGridClick(value) {
    if (value === "a") {
      this.setState({ styleClass: "parentgrid" });
    } else {
      this.setState({ styleClass: "parent" });
    }
  }

  onDragStart = (ev, id) => {
    /* isDroppingNewWidget takes every grid item out of hit-testing for the duration of
       the drag - see the --dropping rules in editorStyles.css and onDragEndTile below. */
    this.setState({ components: id, isDroppingNewWidget: true });
    // without this Firefox refuses the drop and the drag simply dies mid-way
    if (ev?.dataTransfer) {
      ev.dataTransfer.effectAllowed = "move";
      try {
        ev.dataTransfer.setData("text/plain", id || "widget");
      } catch (e) {
        /* older browsers reject setData outside a real drag - safe to ignore */
      }
    }
  };

  /* dragend fires on the SOURCE tile however the drag finishes - dropped on the canvas,
     dropped outside it, or cancelled with Escape - so it is the only handler that is
     guaranteed to run. Clearing on drop alone would leave the canvas inert after a drag
     the user abandoned. */
  onDragEndTile = () => {
    if (this.state.isDroppingNewWidget) this.setState({ isDroppingNewWidget: false });
  };

  // the placeholder shown while dragging must match the item onDrop actually creates
  getDroppingItem = () => {
    const isReport = this.props.dashboardConfig?.boardType === "reports";
    // must match what onDrop creates, or the outline lies about where the widget lands
    return { i: RGL_DROPPING_ITEM_ID, w: isReport ? 12 : 8, h: isReport ? 12 : 11 };
  };

  /* Returning false keeps RGL from inserting its dropping element at all.
     onDrop refuses a drop with no resource selected, or a second widget on a report - but
     RGL had already put the placeholder into its layout by then, and with nothing added
     to clear it the grey block stayed on the canvas behind the widgets. */
  onDropDragOver = () => {
    if (!this.props.selectedResource?.id || !this.canAddWidget()) return false;
    return this.getDroppingItem();
  };

  /* One source of truth for "can canvas widgets be dragged". It drives RGL and the
     grab cursor on the card header, which previously showed a grab hand on reports
     even though dragging was off there - so the canvas looked broken rather than
     locked. Reports stack full-width (onDrop forces x:0, w:12), so they are locked. */
  isCanvasDraggable = () => this.props.dashboardConfig?.boardType !== "reports";

  /* Charts are sized as a percentage of the widget, but ApexCharts only measures its
     container on mount and on a window resize - and resizing a grid item fires neither.
     Without this a resized widget kept its chart at the old size until the page was
     reloaded. Fired on release rather than on every pixel, so it stays cheap. */
  handleWidgetResizeStop = () => {
    window.dispatchEvent(new Event("resize"));
  };

  /* A report holds exactly one widget; a dashboard holds as many as you like.
     A report already stacks its widget full-width at 0,0, so a second one would land on
     top of the first with no way to move it - the layout has nowhere to put it. */
  isSingleWidgetBoard = () => this.props.dashboardConfig?.boardType === "reports";

  canAddWidget = () => !this.isSingleWidgetBoard() || (this.state.layouts?.lg || []).length === 0;

  /* ── NOTHING TO SAVE YET ──────────────────────────────────────────────────
     Why Save, Preview and Publish are held closed until there is a widget on the canvas.

     An empty board saves and publishes perfectly happily, and what reaches the app that
     embeds it is a report with no table and no chart in it - a blank panel the reader
     cannot tell from a broken one, and which the author has no reason to think they
     published. The editor is the only place that can catch it, because by the time it is
     out there the board looks deliberate.

     The test is the canvas, not the resource, and that is on purpose:

       - A widget CANNOT exist without a resource. onDrop refuses a drop while
         selectedResource is empty, so a widget on the canvas is proof that one was picked.
         Checking both would not catch anything this does not.
       - selectedResource is the resource whose panel is OPEN, not the board's contents. It
         is empty on a saved board that has just been re-opened for editing, so requiring
         it would block Save on a perfectly good report until the author happened to click
         a widget.

     Deliberately NOT part of the test: whether that resource returned any rows or any
     columns. An endpoint can be empty today and full tomorrow, and a board built against
     one is still a real board - refusing to save it would make the editor unusable
     against a data source that is merely quiet. */
  editorBlockedReason = () => {
    if ((this.state.layouts?.lg || []).length > 0) return "";
    return this.isSingleWidgetBoard()
      ? "Add a table or a chart to the canvas before saving."
      : "Add at least one table or chart to the canvas before saving.";
  };

  generateLayout() {
    return _.map(_.range(0, 0), function (item, i) {
      // console.log(item)
      var y = Math.ceil(Math.random() * 4) + 1;
      return {
        x: Math.round(Math.random() * 5) * 2,
        y: Math.floor(i / 6) * y,
        w: 2,
        h: y,
        i: i.toString(),
        static: Math.random() < 0.05,
      };
    });
  }

  /* ── A RESOURCE WITH NOTHING DRAWING IT ──────────────────────────────────────
     Removing a widget from the canvas deliberately leaves its resource behind - the
     connection, the fields, the filters are all still configured, and losing them
     because a widget was dragged off would be worse than keeping an unused resource.

     But a board SAVED in that state carries a resource that renders nothing: the view
     page fetches it, waits for it, and draws no widget for it. So the leftover is fine
     while editing and not fine on the way out.

     Matched on the resource's own id against the resourceId each canvas item carries
     (set by changeReslutIds on load and by onDrop on a new widget), rather than on
     counts - two resources and two widgets can still leave one resource unused if both
     widgets were built from the other. */
  orphanedResourceNumbers() {
    const placed = new Set(
      (this.state.layouts?.lg || []).map((el) => el?.resourceId).filter((id) => id !== null && id !== undefined),
    );

    return (this.props.resourceList || [])
      .map((resource, index) => ({ number: index + 1, id: resource?.id }))
      .filter((r) => r.id !== null && r.id !== undefined && !placed.has(r.id))
      .map((r) => r.number);
  }

  /* Says what is wrong and which resource it is wrong on, and answers whether to stop.
     Numbered the way the sidebar numbers them - "Resource 1" there is Resource 1 here -
     so the message points at something the reader can actually find. */
  isBlockedByOrphanedResources() {
    const numbers = this.orphanedResourceNumbers();
    if (!numbers.length) return false;

    const list = numbers.join(", ");
    message.error(
      numbers.length === 1
        ? `Resource ${list} has no widget to display it. Add a widget for it, or remove the resource, before saving or publishing.`
        : `Resources ${list} have no widget to display them. Add a widget for each, or remove them, before saving or publishing.`,
    );
    return true;
  }

  saveDashboardDetails() {
    // this.onPreview();
    if (this.isBlockedByOrphanedResources()) return;

    if (this.props.boardSavingState.status === "DEFAULT") {
      const id = this.props.match?.params?.selectedId || this.props.boardSavingState.id; //this.props.boardSavingState && this.props.boardSavingState.id ? [...this.props.boardSavingState.id][0] : null
      const properties = {
        filters: this.state.filters,
        fullscreen: this.state.fullscreen,
        refresh: this.state.refresh,
        autorefresh: this.state.autorefresh,
        refreshInterval: this.state.refreshInterval,
        csvdownload: this.state.csvdownload,
      };
      this.props.saveDashboardInfo({
        properties: properties,
        publish: false,
        id: id,
      });
    }
  }

  saveAndPublishDashboardDetails() {
    // same gate as Save - a published board is the one readers actually open
    if (this.isBlockedByOrphanedResources()) return;

    if (this.props.boardPublishState.status === "DEFAULT") {
      /* Same id resolution Save uses. This read boardSavingState.id only, which is set
         when a board is saved IN THIS SESSION - so publishing a board opened for editing,
         or publishing before pressing Save, sent id: undefined and quietly did nothing. */
      const id = this.props.match?.params?.selectedId || this.props.boardSavingState.id;

      if (!id) {
        message.warning("Save the board before publishing it");
        return;
      }

      this.props.publishDashboard({ id, publish: true });
    }
  }

  handleLogOut = () => {
    // console.log("LogOut");
    this.props.logOut();
    this.props.history.push("/");
  };

  /* Where leaving the editor lands. The dashboard list hands us the URL it was on
     (`state.from`, page and filters included) so closing the editor puts the user back
     on the page they opened the board from. Opened any other way - a direct URL, the
     board view - there is nothing to go back to, so the plain list stands. */
  returnToList = () => {
    this.props.history.push(this.props.location?.state?.from || "/dashboard-list");
  };

  handleBannerChange = (event, newValue) => {
    //setValue(newValue);
    if (newValue === "refresh") {
      //  setAnchorEl(event.currentTarget);
      //  setPlaying(false);
    } else if (newValue === "autorun") {
      //  actionTimeline();
    } else if (newValue === "fullscreen") {
      // handle.enter();
    } else if (newValue === "reload") {
      // window.location="/report/invoice/"+localStorage.getItem('appid')
    } else if (newValue === "barchart") {
      // handleClickOpen();
      // setPlaying(false);
    } else {
      //  setPlaying(false);
      // handle.exit();
    }
  };

  // handleSelectedWidgetNameChange = (name) => {
  //   this.setState({
  //     activeWidgetName: name,
  //   });
  //   this.props.updateSelectedWidjetName(name);
  // };
  handleSelectedWidgetNameChange = (name) => {
    const isChart = name === "pie" || name === "bar" || name === "line";

    const widgetName = isChart ? "chart" : "table";
    const chartType = name === "pie" ? "Pie" : name === "bar" ? "Bar" : name === "line" ? "Line" : null;

    /* A report holds one widget, so choosing a different type REPLACES it - the canvas is
       cleared and the chart config reset, which is the behaviour that has always been
       here. A dashboard holds many, so choosing a type only arms the next drag: clearing
       the canvas there would silently delete widgets the user had already built. */
    const replacesExisting = this.isSingleWidgetBoard();

    this.setState({
      activeWidgetName: widgetName,
      activeChartType: chartType,
      ...(replacesExisting ? { layouts: { lg: [] } } : {}),
    });

    this.props.updateSelectedWidjetName(widgetName);
    if (replacesExisting) this.props.resetChartConfig(); //  clear charts in redux
  };

  handleUpdateReportName = (e) => {
    this.props.updateDashboardName(e.target.value);
  };

  /* The row/chart serialisation this used to hold inline now lives in
     utils/widgetExport.js, unchanged, because a published board needs the identical
     export from each widget header - see exportRowsToCsv / exportChartToCsv there.
     This button still exports every widget on the canvas at once; the per-widget
     "Allow download" property is what governs the buttons on a published board. */
  handleDownloadCSV = () => {
    const { resourceList } = this.props;

    if (!resourceList || resourceList.length === 0) {
      message.warning("No data available to download");
      return;
    }

    resourceList.forEach((resource) => {
      if (!resource?.reportData) return;

      const widgetName = resource?.source?.widgetName || "report";
      const isChart = resource?.widjet === "chart" && resource?.charts?.chartType;

      const written = isChart
        ? exportChartToCsv({
            rows: resource.reportData,
            groupByField: resource.charts?.groupBy?.fieldName,
            valueField: resource.charts?.fieldName?.fieldName,
            widgetName,
          })
        : exportRowsToCsv({
            rows: Array.isArray(resource?.reportData?.Result)
              ? resource.reportData.Result
              : Array.isArray(resource?.reportData)
                ? resource.reportData
                : [],
            fields: (resource?.availableFields || []).filter((f) => f.checked),
            widgetName,
          });

      if (!written) message.warning(`No data to download for ${widgetName}`);
    });
  };

  // render() {
  //   const { activeKey, visible } = this.state;
  //   return (
  //     <>
  //       <DashboardLayout>
  //         <DashboardLayout.AppBar
  //           appTitleProps={{
  //             appTitle: "Witmeg Reporting",
  //             appSubtitle: "Report Engine",
  //             appLogoUrl:
  //               "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSG5Omn5Fd0IYMYavsfGgXhc2guce2dLKv01X7zxSkPcO6kE4ZiVoqre-VOGLDSHPpEAZE&usqp=CAU",
  //             onClick: () => {
  //               this.props.history.push("/");
  //             },
  //           }}
  //           pageTitleProps={{
  //             pageTitle: "Dynamic Reports",
  //             pageSubtitle: "Customize Easy",
  //             onClick: () => {
  //               console.log("PageTitle CLICKED");
  //             },
  //           }}
  //           userMenuProps={{
  //             avatarValue:
  //               JSON.parse(localStorage.getItem("fullUserDetails")).FirstName.charAt(0) +
  //               JSON.parse(localStorage.getItem("fullUserDetails")).LastName.charAt(0),
  //             avatarIcon: <AndroidFilledIcon />,
  //             title:
  //               JSON.parse(localStorage.getItem("fullUserDetails")).FirstName +
  //               " " +
  //               JSON.parse(localStorage.getItem("fullUserDetails")).LastName,
  //             subTitle: "JohnDoe@Gmail.com",
  //             menuItems: [
  //               {
  //                 menuTitle: "Log Out",
  //                 menuIcon: <LogoutIcon />,
  //                 onClick: () => {
  //                   console.log("UserMenu -> LogOut CLICKED");
  //                   this.handleLogOut();
  //                 },
  //               },
  //             ],
  //           }}
  //           settingsMenuProps={{
  //             menuItems: [
  //               {
  //                 menuTitle: "User Settings",
  //                 menuIcon: <UserIcon />,
  //                 onClick: () => {
  //                   console.log("SettingsMenu -> UserSettings CLICKED");
  //                 },
  //               },
  //             ],
  //           }}
  //           messageMenuProps={{
  //             messageList: [
  //               {
  //                 avatarValue: "AB",
  //                 title: "New Data Added",
  //                 subtitle: "Noodles Added To Inventory.",
  //               },
  //             ],
  //           }}
  //         />

  //         <DashboardLayout.MainContent
  //         // breadcrumbProps={{
  //         // 	breadcrumbRoutes: [
  //         // 		{ breadcrumbName: 'Home', breadcrumbIcon: <HomeIcon /> },
  //         // 	],
  //         // }}
  //         >
  //           {localStorage.getItem("IsSpecialUser") ||
  //           (this.props.currentAppPermissions && this.props.currentAppPermissions.indexOf("CreateDashboard") > -1) ? (
  //             <>
  //               <SplitPane
  //                 split="horizontal"
  //                 defaultSize="60%"
  //                 onChange={(size) => {
  //                   this.setState({ splitPosition: size });
  //                 }}
  //               >
  //                 <Row style={{ marginTop: "72px" }}>
  //                   {/* <Col span={24}>
  //                 &nbsp;
  //               </Col>
  //               <Col span={24}>
  //                 &nbsp;
  //               </Col> */}
  //                   <Col span={24}>
  //                     {/* <Navbar bg="light" expand="lg">
  //                   <Navbar.Brand href="#home">Report editor</Navbar.Brand>
  //                   <Navbar.Toggle aria-controls="basic-navbar-nav" />
  //                   <Navbar.Collapse id="basic-navbar-nav">
  //                     <Button variant="outline-success" onClick={this.onPreview} size="small" ><EyeOutlined style={{ fontSize: '20px' }} /> Preview</Button>&nbsp;
  //                     <Button variant="outline-success" onClick={() => { this.saveDashboardDetails(); }}><SaveOutlined style={{ fontSize: '20px' }} /> Save  </Button>&nbsp;
  //                     <Button variant="outline-success" onClick={() => { this.saveAndPublishDashboardDetails(); }} disabled={this.props.boardSavingState && this.props.boardSavingState.status && this.props.boardSavingState.status !== 'SUCCESS'}><PublishIcon style={{ fontSize: '20px' }} />Publish </Button>
  //                   </Navbar.Collapse>
  //                 </Navbar> */}

  //                     <div
  //                       style={{
  //                         display: "flex",
  //                         width: "100%",
  //                       }}
  //                     >
  //                       <div style={{ marginRight: "1rem" }}>
  //                         <Button type="link" onClick={() => this.props.history.goBack()}>
  //                           <BackIcon />
  //                         </Button>

  //                         <span style={{ fontSize: "18px", fontWeight: "bold" }}>Report / Dashboard Editor</span>
  //                       </div>
  //                       <div>
  //                         <Space>
  //                           <Button icon={<EyeOutlined />} onClick={this.onPreview}>
  //                             Preview
  //                           </Button>
  //                           <Button
  //                             icon={<SaveOutlined />}
  //                             onClick={() => {
  //                               this.saveDashboardDetails();
  //                             }}
  //                           >
  //                             Save
  //                           </Button>
  //                           <Button
  //                             icon={
  //                               <MaterialDesignIcon icon="publish" styles={{ fontSize: "12px", paddingRight: "4px" }} />
  //                             }
  //                             onClick={() => {
  //                               this.saveAndPublishDashboardDetails();
  //                             }}
  //                           >
  //                             Publish
  //                           </Button>
  //                         </Space>
  //                       </div>
  //                       <div style={{ marginLeft: "5rem" }}>
  //                         <div style={{ fontSize: "16px", fontWeight: 500, display: "flex", alignItems: "center" }}>
  //                           <div> Name:&nbsp;</div>
  //                           <Input
  //                             value={this.props?.dashboardConfig?.boardName}
  //                             onChange={this.handleUpdateReportName}
  //                           />
  //                         </div>
  //                       </div>
  //                     </div>
  //                   </Col>
  //                   <Col span={20} className="MiddleCol">
  //                     <div className="Split12" style={{ overflowY: "auto" }}>
  //                       <ResponsiveReactGridLayout
  //                         {...this.props}
  //                         layout={this.state.layout}
  //                         onLayoutChange={this.onLayoutChange}
  //                         onDrop={this.onDrop}
  //                         droppingItem={this.props.item}
  //                         measureBeforeMount={false}
  //                         useCSSTransforms={this.state.mounted}
  //                         compactType={this.state.compactType}
  //                         preventCollision={true}
  //                         isDroppable={true}
  //                         isDraggable={
  //                           this.props.dashboardConfig &&
  //                           this.props.dashboardConfig.boardType &&
  //                           this.props.dashboardConfig.boardType === "reports"
  //                             ? false
  //                             : true
  //                         }
  //                       >
  //                         {_.map(this.state.layouts.lg, (el) => this.generateDOM(el))}
  //                       </ResponsiveReactGridLayout>
  //                     </div>
  //                   </Col>
  //                   <Col span={4}>
  //                     <Tabs
  //                       defaultActiveKey={"" + activeKey}
  //                       onChange={this.handleChange}
  //                       activeKey={"" + activeKey}
  //                       id="tab1"
  //                     >
  //                       <TabPane
  //                         tab={
  //                           <span>
  //                             <BugOutlined />
  //                             Properties
  //                           </span>
  //                         }
  //                         key="1"
  //                       >
  //                         <Tabs defaultActiveKey="1" type="card" size="small">
  //                           <TabPane tab="Components" key="1">
  //                             <Switch
  //                               size="small"
  //                               onClick={this.onToggle.bind(this, "refresh")}
  //                               checked={this.state.refresh}
  //                             />{" "}
  //                             Show refresh button <br />
  //                             <Switch
  //                               size="small"
  //                               onClick={this.onToggle.bind(this, "autorefresh")}
  //                               checked={this.state.autorefresh}
  //                             />{" "}
  //                             Show auto refresh
  //                             <br />
  //                             {this.state.autorefresh ? (
  //                               <div style={{ padding: "6px" }}>
  //                                 Refresh :
  //                                 <Select
  //                                   value={this.state.refreshInterval}
  //                                   onChange={(val) => this.setState({ refreshInterval: val })}
  //                                 >
  //                                   <Select.Option value="30s">30 Seconds</Select.Option>
  //                                   <Select.Option value="1m">1 Minute</Select.Option>
  //                                   <Select.Option value="5m">5 Minutes</Select.Option>
  //                                   <Select.Option value="10m">10 Minutes</Select.Option>
  //                                   <Select.Option value="1h">1 Hour</Select.Option>
  //                                   <Select.Option value="3h">3 Hours</Select.Option>
  //                                   <Select.Option value="never">Never</Select.Option>
  //                                 </Select>
  //                               </div>
  //                             ) : null}
  //                             <Switch
  //                               size="small"
  //                               onClick={this.onToggle.bind(this, "fullscreen")}
  //                               checked={this.state.fullscreen}
  //                             />{" "}
  //                             Show full screen button
  //                             <br />
  //                             <Switch
  //                               size="small"
  //                               onClick={this.onToggle.bind(this, "csvdownload")}
  //                               checked={this.state.csvdownload}
  //                             />{" "}
  //                             Allow csv download
  //                             <br />
  //                             <Switch
  //                               size="small"
  //                               onClick={this.onToggle.bind(this, "filters")}
  //                               checked={this.state.filters}
  //                             />{" "}
  //                             Show filters
  //                             <br />
  //                           </TabPane>

  //                           <TabPane tab="Modules" key="2">
  //                             to do
  //                           </TabPane>
  //                         </Tabs>
  //                       </TabPane>
  //                       <TabPane
  //                         tab={
  //                           <span>
  //                             <InsertRowBelowOutlined />
  //                             Insert
  //                           </span>
  //                         }
  //                         key="2"
  //                       >
  //                         <Tabs defaultActiveKey="1" type="card" size="small">
  //                           <TabPane tab="Components" key="1">
  //                             <Row>
  //                               <Col span={16}>
  //                                 <Search
  //                                   placeholder="Search modules"
  //                                   size="large"
  //                                   onSearch={onSearch}
  //                                   style={{ width: "100%" }}
  //                                 />
  //                               </Col>
  //                               <Col span={8}>
  //                                 <Radio.Group defaultValue="a" size="large">
  //                                   <Radio.Button onClick={this.onGridClick.bind(this, "a")} value="a">
  //                                     <UnorderedListOutlined />
  //                                   </Radio.Button>
  //                                   <Radio.Button onClick={this.onGridClick.bind(this, "b")} value="b">
  //                                     <AppstoreOutlined />
  //                                   </Radio.Button>
  //                                 </Radio.Group>
  //                               </Col>
  //                             </Row>

  //                             <div className={this.state.styleClass}>
  //                               <div
  //                                 className={this.state.activeWidgetName === "table" ? "child active-widget" : "child"}
  //                               >
  //                                 <Paragraph>
  //                                   <div className="prediv">
  //                                     <div
  //                                       className="droppable-element"
  //                                       draggable={this.state.activeWidgetName === "table"}
  //                                       unselectable="on"
  //                                       onDragStart={(e) => this.onDragStart(e, "table")}
  //                                       onClick={() => this.handleSelectedWidgetNameChange("table")}
  //                                     >
  //                                       <TableOutlined
  //                                         style={{
  //                                           fontSize: "250%",
  //                                           color: "#08c",
  //                                         }}
  //                                       />
  //                                       <div>
  //                                         Table <span>Display data in tabular format </span>
  //                                       </div>
  //                                     </div>
  //                                   </div>
  //                                 </Paragraph>
  //                               </div>
  //                               <div
  //                                 className={this.state.activeWidgetName === "chart" ? "child active-widget" : "child"}
  //                               >
  //                                 <Paragraph>
  //                                   <div className="prediv">
  //                                     <div
  //                                       className="droppable-element"
  //                                       draggable={this.state.activeWidgetName === "chart"}
  //                                       unselectable="on"
  //                                       onDragStart={(e) => this.onDragStart(e, "chart")}
  //                                       onClick={() => this.handleSelectedWidgetNameChange("chart")}
  //                                     >
  //                                       <BarChartOutlined
  //                                         style={{
  //                                           fontSize: "250%",
  //                                           color: "#08c",
  //                                         }}
  //                                       />
  //                                       <div>
  //                                         Chart <span>Visual your data into graph </span>
  //                                       </div>
  //                                     </div>
  //                                   </div>
  //                                 </Paragraph>
  //                               </div>

  //                               {/* <div className="child">

  //                             <Paragraph>

  //                               <div className="prediv"><div
  //                                 className="droppable-element"
  //                                 draggable={true}
  //                                 unselectable="on"
  //                                 onDragStart={(e) => this.onDragStart(e, "image")}
  //                               >
  //                                 <FileImageOutlined style={{ fontSize: '250%', color: '#08c' }} />
  //                                 <div>Image <span>Display any image </span></div>
  //                               </div></div>
  //                             </Paragraph>

  //                           </div> */}
  //                             </div>
  //                           </TabPane>
  //                           <TabPane tab="Modules" key="2">
  //                             Content of card tab 2
  //                           </TabPane>
  //                         </Tabs>
  //                       </TabPane>
  //                     </Tabs>
  //                   </Col>
  //                 </Row>

  //                 <Row>
  //                   <Col span={24}>
  //                     <ResourceEditor
  //                       splitPosition={this.state.splitPosition}
  //                       activeWidgetName={this.state.activeWidgetName}
  //                     />
  //                   </Col>
  //                 </Row>
  //               </SplitPane>
  //             </>
  //           ) : (
  //             <NoPermission />
  //           )}
  //         </DashboardLayout.MainContent>
  //       </DashboardLayout>
  //     </>
  //   );
  // }

  render() {
    const { activeKey, visible } = this.state;
    const dd = this.getDrillDown(); // per-widget drill-down config
    // empty while the board is publishable; otherwise what is stopping it
    const blockedReason = this.editorBlockedReason();

    return (
      <>
        {/* {this.props.isLoadingDashboard && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              backgroundColor: "rgba(0, 0, 0, 0.6)",
              zIndex: 9999,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <Spin size="large" indicator={<LoadingOutlined style={{ fontSize: 40, color: "#fff" }} spin />} />
            <span style={{ color: "#fff", fontSize: "14px", fontWeight: 500 }}>Loading report, please wait...</span>
          </div>
        )} */}
        {(this.props.isLoadingDashboard || this.props.isRefreshing) && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              backgroundColor: "rgba(255, 255, 255, 0.6)", // lighter — white not black
              zIndex: 9998,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: "12px",
              backdropFilter: "blur(2px)",
            }}
          >
            <Spin size="large" indicator={<LoadingOutlined style={{ fontSize: 40, color: "#1a2e5a" }} spin />} />
            <span style={{ color: "#1a2e5a", fontSize: "14px", fontWeight: 500 }}>
              {this.props.isLoadingDashboard ? "Loading report, please wait..." : "Refreshing data..."}
            </span>
          </div>
        )}
        {/* A failed load used to leave the editor looking like an empty board, which is
            indistinguishable from a report with nothing in it. Say what happened. */}
        {this.props.dashboardLoadError && !this.props.isLoadingDashboard ? (
          <div className="editor-load-error">
            <span>{this.props.dashboardLoadError}</span>
            <button onClick={() => window.location.reload()}>Retry</button>
          </div>
        ) : null}
        {/* ── MAIN EDITOR SHELL ── */}
        <div className="editor-shell">
          {/* TOP BAR */}
          <div className="editor-topbar">
            <div className="editor-topbar-left">
              {/* Back arrow removed so the title starts flush left - Cancel on the right
                  already leaves the editor. Kept in case we want it back. */}
              {/* <Button type="link" onClick={() => this.props.history.goBack()}>
                <BackIcon />
              </Button> */}
              <h2 className="editor-topbar-title">
                Dynamic Reports
                <span>Customize Easy</span>
              </h2>
            </div>
            <div className="editor-topbar-right">
              <Space>
                {/* goBack() landed wherever the editor happened to be opened from - the
                    dashboard list, a board, or nowhere at all on a direct URL. Leaving the
                    editor now always ends up in the same place. */}
                <button className="btn-cancel" onClick={this.returnToList}>
                  <img src={CloseIcon} alt="cancel-icon" className="top-btn-icon" />
                  Cancel
                </button>

                {/* Held closed until the canvas has something on it - see
                    editorBlockedReason. The reason is the tooltip on all three, so the
                    author is told what is missing rather than left with three dead
                    buttons. Cancel stays live: leaving an empty board is exactly what
                    someone who cannot save one wants to do. */}
                <button
                  className="btn-preview"
                  disabled={Boolean(blockedReason)}
                  title={blockedReason || "Preview this board"}
                  onClick={this.onPreview}
                >
                  <img src={EyeIcon} alt="preview-icon" className="top-btn-icon" />
                  Preview
                </button>

                <button
                  className="btn-save"
                  disabled={Boolean(blockedReason)}
                  title={blockedReason || "Save this board"}
                  onClick={() => this.saveDashboardDetails()}
                >
                  <img src={SaveIcon} alt="save-icon" className="top-btn-icon" />
                  Save
                </button>

                <button
                  className="btn-publish"
                  icon={<MaterialDesignIcon icon="publish" />}
                  disabled={Boolean(blockedReason)}
                  title={blockedReason || "Publish this board"}
                  onClick={() => this.saveAndPublishDashboardDetails()}
                >
                  <img src={PublishIcon} alt="public-icon" className="top-btn-icon" />
                  Publish
                </button>
              </Space>
            </div>
          </div>

          {/* ── 3-COLUMN BODY ── */}
          <div className="editor-body">
            {/* LEFT SIDEBAR */}
            <div className="editor-left-sidebar">
              {/* <p style={{ padding: "16px", color: "#999" }}>Left sidebar</p> */}
              <div className="left-sidebar-heading">
                Configurations
                {/* Everything below edits ONE resource. On a dashboard that is
                    ambiguous until it is named. */}
                {this.renderActiveResourceLabel()}
              </div>
              <ResourceEditor
                activeWidgetName={this.state.activeWidgetName}
                activeChartType={this.state.activeChartType}
                onWidgetSelect={this.handleSelectedWidgetNameChange}
                onDragStart={this.onDragStart}
              />
            </div>

            {/* CENTER CANVAS */}
            <div className="editor-center" ref={this.canvasRef}>
              {/* canvas sub-toolbar */}
              {/* <div className="editor-canvas-toolbar">
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <span style={{ fontWeight: 500 }}>Name:</span>
                  <Input
                    value={this.props?.dashboardConfig?.boardName}
                    onChange={this.handleUpdateReportName}
                    style={{ width: 200 }}
                  />
                </div>
              </div> */}
              <div className="editor-canvas-toolbar">
                {/* LEFT */}
                <div className="editor-toolbar-left">
                  <div className="toolbar-field-group">
                    <label className="toolbar-label">Name:</label>

                    <Input
                      className="toolbar-input"
                      value={this.props?.dashboardConfig?.boardName}
                      onChange={this.handleUpdateReportName}
                      placeholder="Dashboard Name"
                    />
                  </div>

                  <div className="toolbar-field-group">
                    {/* <label className="toolbar-label">Date Range</label>

                    <Select className="toolbar-select" defaultValue="Last 30 days">
                      <Select.Option value="30">Last 30 days</Select.Option>

                      <Select.Option value="7">Last 7 days</Select.Option>

                      <Select.Option value="90">Last 90 days</Select.Option>
                    </Select> */}
                  </div>
                </div>

                {/* RIGHT */}
                <div className="editor-toolbar-actions">
                  <Button
                    className="toolbar-btn"
                    onClick={() => this.props.fetchAllResourceData()}
                    loading={this.props.isRefreshing}
                    disabled={this.props.isRefreshing}
                  >
                    <img src={RefreshIcon} alt="refreshIcon" className="toolbar-btn-icon" />
                    {this.props.isRefreshing ? "Refreshing..." : "Refresh"}
                  </Button>

                  <Button className="toolbar-btn" onClick={this.handleFullScreen}>
                    <img src={FullscreenIcon} alt="fullscreenIcon" className="toolbar-btn-icon" />
                    {this.state.isFullScreen ? "Exit Full Screen" : "Full Screen"}
                  </Button>

                  <Button className="toolbar-btn" onClick={this.handleDownloadCSV}>
                    <img src={DownloadIcon} alt="downloadIcon" className="toolbar-btn-icon" />
                    Download CSV
                  </Button>
                </div>
              </div>

              {/* the grid */}
              <div
                className={`editor-canvas-grid${this.isCanvasDraggable() ? "" : " editor-canvas-grid--static"}${
                  this.state.isDroppingNewWidget ? " editor-canvas-grid--dropping" : ""
                }`}
              >
                {localStorage.getItem("IsSpecialUser") ||
                (this.props.currentAppPermissions &&
                  this.props.currentAppPermissions.indexOf("CreateDashboard") > -1) ? (
                  <ResponsiveReactGridLayout
                    /* WidthProvider only measures the container on mount and on window
                       resize, and the resize that fullscreen fires lands before the
                       transition finishes - so from the second toggle on it kept a stale
                       width and drew the widgets at half size. Changing the key remounts
                       the grid, which forces a fresh measurement. */
                    key={this.state.isFullScreen ? "grid-fullscreen" : "grid-normal"}
                    {...this.props}
                    /* ── ONE BREAKPOINT, 12 COLUMNS, ALWAYS ──
                       This is why widgets could not be moved sideways. The canvas sits
                       between two 300px+ sidebars, so it measures roughly 950-1050px -
                       which is RGL's "md" breakpoint, and md was configured for SIX
                       columns. Widgets are created 8 wide, so md clamped every one of
                       them to 6 of 6: full width, x pinned to 0, no horizontal movement
                       and nothing to resize into. The drag looked broken because the
                       widget genuinely had nowhere else to go.

                       The editor edits a single saved layout (layouts.lg, saved per
                       resource), so responsive breakpoints have nothing to offer here -
                       they only reinterpret it at a column count it was never designed
                       for. A breakpoint at width 0 means "lg" always wins. */
                    breakpoints={{ lg: 0 }}
                    cols={{ lg: 12 }}
                    layout={this.state.layout}
                    onLayoutChange={this.onLayoutChange}
                    onDrop={this.onDrop}
                    /* this.props.item is undefined, so the drop placeholder fell back to
                       RGL's 1x1 default while the item created is 8x8 (12x12 for reports).
                       Matching them makes the preview land where the widget actually goes. */
                    droppingItem={this.getDroppingItem()}
                    onDropDragOver={this.onDropDragOver}
                    measureBeforeMount={false}
                    useCSSTransforms={this.state.mounted}
                    compactType={this.state.compactType}
                    /* preventCollision rejected any drop that overlapped an existing
                       widget - silently, which read as "the drag got stuck". Letting items
                       push each other means a drop always lands. */
                    preventCollision={false}
                    isDroppable={this.canAddWidget()}
                    isDraggable={this.isCanvasDraggable()}
                    /* Without this, RGL starts a drag from a mousedown anywhere in the
                       card - including inside the table, so selecting a cell value to
                       copy it dragged the widget instead. */
                    draggableCancel={ResizableHandles.DRAG_CANCEL}
                    onResizeStop={this.handleWidgetResizeStop}
                  >
                    {_.map(this.state.layouts.lg, (el) => this.generateDOM(el))}
                  </ResponsiveReactGridLayout>
                ) : (
                  <NoPermission />
                )}
              </div>
            </div>

            {/* RIGHT SIDEBAR */}
            <div className="editor-right-sidebar">
              {/* ── TOP TABS ── */}
              <div className="right-sidebar-tabs">
                <div
                  className={
                    this.state.rightSidebarTab === "properties" ? "right-sidebar-tab active" : "right-sidebar-tab"
                  }
                  onClick={() => this.setState({ rightSidebarTab: "properties" })}
                >
                  Properties
                </div>

                <div
                  className={this.state.rightSidebarTab === "insert" ? "right-sidebar-tab active" : "right-sidebar-tab"}
                  onClick={() => this.setState({ rightSidebarTab: "insert" })}
                >
                  Insert
                </div>
              </div>

              {/* ── PROPERTIES TAB ── */}
              {this.state.rightSidebarTab === "properties" && (
                <Collapse
                  defaultActiveKey={["columns"]}
                  ghost
                  className="right-sidebar-collapse"
                  expandIconPosition="end"
                >
                  {/* ── COLUMNS ── */}
                  <Panel header="Columns" key="columns">
                    <ResourceFilters
                      reportDataObject={this.props.selectedResource?.reportData || null}
                      availableFields={this.props.selectedResource?.availableFields || null}
                      updateSelectedFields={this.props.handleUpdateSelectedFields}
                      reOrderFields={this.props.handleReOrderFields}
                      reportDataStatus={
                        this.props.isLoadingDashboard || this.props.isRefreshing
                          ? "pending"
                          : this.props.selectedResource?.reportData
                            ? "success"
                            : "default"
                      }
                    />
                  </Panel>

                  {/* ── DISPLAY PROPERTIES ── */}
                  {/* <Panel header="Display Properties" key="display-properties">
                    <div className="display-prop-row">
                      <Switch size="small" onClick={this.onToggle.bind(this, "refresh")} checked={this.state.refresh} />
                      <span>Display refresh button</span>
                    </div>

                    <div className="display-prop-row">
                      <Switch
                        size="small"
                        onClick={this.onToggle.bind(this, "autorefresh")}
                        checked={this.state.autorefresh}
                      />
                      <span>Allow auto refresh</span>
                    </div>

                    {this.state.autorefresh ? (
                      <div style={{ paddingLeft: "24px", paddingBottom: "8px" }}>
                        <span style={{ fontSize: "12px", marginRight: "8px" }}>Interval:</span>

                        <Select
                          value={this.state.refreshInterval}
                          onChange={(val) => this.setState({ refreshInterval: val })}
                          size="small"
                          style={{ width: 120 }}
                        >
                          <Select.Option value="30s">30 Seconds</Select.Option>

                          <Select.Option value="1m">1 Minute</Select.Option>

                          <Select.Option value="5m">5 Minutes</Select.Option>

                          <Select.Option value="10m">10 Minutes</Select.Option>

                          <Select.Option value="1h">1 Hour</Select.Option>

                          <Select.Option value="3h">3 Hours</Select.Option>

                          <Select.Option value="never">Never</Select.Option>
                        </Select>
                      </div>
                    ) : null}

                    <div className="display-prop-row">
                      <Switch
                        size="small"
                        onClick={this.onToggle.bind(this, "fullscreen")}
                        checked={this.state.fullscreen}
                      />
                      <span>Display full screen button</span>
                    </div>

                    <div className="display-prop-row">
                      <Switch
                        size="small"
                        onClick={this.onToggle.bind(this, "csvdownload")}
                        checked={this.state.csvdownload}
                      />
                      <span>Allow csv download</span>
                    </div>

                    <div className="display-prop-row">
                      <Switch size="small" onClick={this.onToggle.bind(this, "filters")} checked={this.state.filters} />
                      <span>Display filters</span>
                    </div>

                    <div className="display-prop-row">
                      <Switch size="small" disabled />
                      <span>Enable Drill Down</span>
                    </div>

                    <div className="display-prop-row">
                      <Switch size="small" disabled />
                      <span>Allow this report to be used for drill down</span>
                    </div>
                  </Panel> */}
                  {/* ── DISPLAY PROPERTIES ──
                      Two levels on a dashboard. Refresh and auto refresh reload the
                      whole page, so they can only be board-level; download and full
                      screen act on one widget's data, so on a dashboard they belong to
                      the widget. A report holds exactly one widget, so it keeps the
                      single flat list it always had. See renderWidgetDisplayProps(). */}
                  <Panel header="Display Properties" key="display-properties">
                    {!this.isSingleWidgetBoard() ? <div className="prop-level-label">Board</div> : null}
                    <div className="prop-toggle-list">
                      <div className="display-prop-row">
                        <Switch onClick={this.onToggle.bind(this, "refresh")} checked={this.state.refresh} />
                        <span>Display refresh button</span>
                      </div>

                      <div className="display-prop-row">
                        <Switch onClick={this.onToggle.bind(this, "autorefresh")} checked={this.state.autorefresh} />
                        <span>Allow auto refresh</span>
                      </div>

                      {this.state.autorefresh && (
                        <div className="prop-interval-row">
                          <span className="prop-interval-label">Interval:</span>
                          <Select
                            value={this.state.refreshInterval}
                            onChange={(val) => this.setState({ refreshInterval: val })}
                            size="small"
                            style={{ width: 120 }}
                          >
                            <Select.Option value="30s">30 Seconds</Select.Option>
                            <Select.Option value="1m">1 Minute</Select.Option>
                            <Select.Option value="5m">5 Minutes</Select.Option>
                            <Select.Option value="10m">10 Minutes</Select.Option>
                            <Select.Option value="1h">1 Hour</Select.Option>
                            <Select.Option value="3h">3 Hours</Select.Option>
                            <Select.Option value="never">Never</Select.Option>
                          </Select>
                        </div>
                      )}

                      <div className="display-prop-row">
                        <Switch onClick={this.onToggle.bind(this, "fullscreen")} checked={this.state.fullscreen} />
                        <span>Display full screen button</span>
                      </div>

                      {/* On a dashboard this moves to each widget below — one board-wide
                          download makes no sense once there are several tables. */}
                      {this.isSingleWidgetBoard() ? (
                        <div className="display-prop-row">
                          <Switch onClick={this.onToggle.bind(this, "csvdownload")} checked={this.state.csvdownload} />
                          <span>Allow csv download</span>
                        </div>
                      ) : null}

                      {/* <div className="display-prop-row">
                        <Switch onClick={this.onToggle.bind(this, "filters")} checked={this.state.filters} />
                        <span>Display filters</span>
                      </div> */}
                    </div>

                    {this.renderWidgetDisplayProps()}
                  </Panel>

                  {/* ── DRILL DOWN ── */}
                  <Panel header="Drill Down" key="drill-down">
                    <div className="prop-toggle-list">
                      <div className="display-prop-row">
                        <Switch
                          checked={dd.enabled}
                          onChange={(checked) => this.patchDrillDown({ enabled: checked })}
                        />
                        <span>Enable Drill Down</span>
                      </div>
                      <div className="display-prop-row">
                        <Switch
                          checked={dd.allowAsTarget}
                          onChange={(checked) => this.patchDrillDown({ allowAsTarget: checked })}
                        />
                        <span>Allow this report to be used for drill-down</span>
                      </div>
                    </div>

                    {/* Nested collapse — no header background */}
                    <Collapse ghost className="drill-down-nested-collapse" expandIconPosition="end">
                      {/* ── TRIGGER TYPE ── */}
                      <Panel header="Trigger Type" key="trigger-type">
                        <div className="drill-trigger-group">
                          <label className="drill-radio-row">
                            <input
                              type="radio"
                              name="triggerType"
                              value="row"
                              checked={dd.triggerType === "row"}
                              onChange={() => this.setTriggerType("row")}
                            />
                            <span>Row Click</span>
                          </label>
                          <label className="drill-radio-row">
                            <input
                              type="radio"
                              name="triggerType"
                              value="cell"
                              checked={dd.triggerType === "cell"}
                              onChange={() => this.setTriggerType("cell")}
                            />
                            <span>Cell Click</span>
                          </label>
                        </div>

                        {/* ── CELL CLICK CONFIGURATION ── */}
                        {dd.triggerType === "cell" ? (
                          <div className="cell-config">
                            <div className="cell-config-title">Cell Click Configuration</div>

                            {dd.cellColumns.map((col) => (
                              <div className="cell-config-column" key={`cell_col_${col.id}`}>
                                <div className="drill-field-group">
                                  <span className="drill-field-label">
                                    Column <span className="drill-required">*</span>
                                  </span>
                                  <div className="cell-config-column-head">
                                    <Select
                                      className="drill-select"
                                      style={{ width: "100%" }}
                                      placeholder="Select column"
                                      value={col.column}
                                      onChange={(val) => this.updateCellColumn(col.id, { column: val })}
                                    >
                                      {(this.props.selectedResource?.availableFields || []).map((af) => (
                                        <Select.Option key={af.id ?? af.fieldName} value={af.fieldName}>
                                          {af.fieldDisplayName || af.fieldName}
                                        </Select.Option>
                                      ))}
                                    </Select>
                                    {dd.cellColumns.length > 1 ? (
                                      <button
                                        className="drill-mapping-delete"
                                        onClick={() => this.removeCellColumn(col.id)}
                                      >
                                        <img src={TrashIcon} alt="delete-icon" />
                                      </button>
                                    ) : null}
                                  </div>
                                </div>

                                {/* OLD PER-CELL BLOCK (kept for revert) - it asked for a cell
                                    VALUE so only cells holding that value were clickable. Per
                                    the meeting the whole column is linkable, so Select Cell and
                                    the per-cell targets are gone.

                                {col.cells.map((cell, cellIndex) => (
                                <div className="cell-card" key={`cell_${col.id}_${cell.id}`}>
                                <div className="cell-card-head">
                                <span className="cell-card-title">Cell {cellIndex + 1}</span>
                                {col.cells.length > 1 ? (
                                <button
                                className="drill-mapping-delete"
                                onClick={() => this.removeCell(col.id, cell.id)}
                                >
                                <img src={TrashIcon} alt="delete-icon" />
                                </button>
                                ) : null}
                                </div>
                                
                                <div className="drill-field-group">
                                <span className="drill-field-label">
                                Select Cell <span className="drill-required">*</span>
                                </span>
                                <div className="cell-picker-row">
                                <Input
                                className="cell-input"
                                placeholder="1200"
                                value={cell.value}
                                onChange={(e) => this.updateCell(col.id, cell.id, { value: e.target.value })}
                                />
                                <button className="cell-picker-btn" title="Pick a cell value">
                                <TableOutlined />
                                </button>
                                </div>
                                <span className="cell-help-text">
                                Type or pick a cell value. When user clicks this cell value in the selected
                                column, the action will be triggered.
                                </span>
                                </div>
                                
                                <div className="drill-field-group">
                                <span className="drill-field-label">
                                Target Type <span className="drill-required">*</span>
                                </span>
                                <Select
                                className="drill-select"
                                style={{ width: "100%" }}
                                value={cell.actionType}
                                onChange={(val) => this.updateCell(col.id, cell.id, { actionType: val })}
                                >
                                <Select.Option value="report">Target Report</Select.Option>
                                <Select.Option value="external">External Service</Select.Option>
                                </Select>
                                </div>
                                
                                {cell.actionType === "report" ? (
                                <div className="cell-action-card cell-action-card--report">
                                <div className="cell-action-card-title">Target Report Configuration</div>
                                <div className="drill-field-group">
                                <span className="drill-field-label">
                                Select Report <span className="drill-required">*</span>
                                </span>
                                <Select
                                className="drill-select"
                                style={{ width: "100%" }}
                                placeholder="Select report..."
                                value={cell.reportId}
                                onChange={(val) => this.updateCell(col.id, cell.id, { reportId: val })}
                                >
                                {this.getTargetReportOptions().map((bd) => (
                                <Select.Option key={bd.id} value={bd.id}>
                                {bd.name}
                                </Select.Option>
                                ))}
                                </Select>
                                </div>
                                <div className="cell-action-info">
                                <div className="external-info-icon">i</div>
                                <span>
                                When the selected cell is clicked, the system will open the above report
                                with mapped values.
                                </span>
                                </div>
                                </div>
                                ) : (
                                <div className="cell-action-card cell-action-card--external">
                                <div className="cell-action-card-title">External Service Configuration</div>
                                <div className="drill-field-group">
                                <span className="drill-field-label">
                                Service URL <span className="drill-required">*</span>
                                </span>
                                <textarea
                                className="external-url-input"
                                placeholder="https://api.example.com/report?customerId={CustomerID}&branch={BranchCode}"
                                rows={3}
                                value={cell.serviceUrl || ""}
                                onChange={(e) =>
                                this.updateCell(col.id, cell.id, { serviceUrl: e.target.value })
                                }
                                />
                                </div>
                                <span className="cell-help-text">
                                When the selected cell is clicked, the system will call this service URL.
                                </span>
                                </div>
                                )}
                                </div>
                                ))}
                                
                                <button className="drill-mapping-add" onClick={() => this.addCell(col.id)}>
                                + Add Cell
                                </button>
                                */}

                                <span className="cell-help-text">Every value in this column becomes a link.</span>

                                <div className="drill-field-group">
                                  <span className="drill-field-label">
                                    Target Type <span className="drill-required">*</span>
                                  </span>
                                  <Select
                                    className="drill-select"
                                    style={{ width: "100%" }}
                                    value={col.actionType || "report"}
                                    onChange={(val) => this.setCellActionType(col.id, val)}
                                  >
                                    <Select.Option value="report">Target Report</Select.Option>
                                    <Select.Option value="external">External Service</Select.Option>
                                  </Select>
                                </div>

                                {(col.actionType || "report") === "report" ? (
                                  <div className="cell-action-card cell-action-card--report">
                                    <div className="cell-action-card-title">Target Report Configuration</div>

                                    <div className="drill-field-group">
                                      <span className="drill-field-label">
                                        Select Report <span className="drill-required">*</span>
                                      </span>
                                      <Select
                                        showSearch
                                        className="drill-select"
                                        style={{ width: "100%" }}
                                        placeholder="Select report..."
                                        optionFilterProp="children"
                                        value={col.reportId}
                                        onChange={(val) =>
                                          this.updateCellColumn(col.id, { reportId: val, targetField: undefined })
                                        }
                                      >
                                        {this.getTargetReportOptions().map((bd) => (
                                          <Select.Option key={bd.id} value={bd.id}>
                                            {bd.name}
                                          </Select.Option>
                                        ))}
                                      </Select>
                                    </div>

                                    <div className="drill-field-group">
                                      <span className="drill-field-label">
                                        Match With Field <span className="drill-required">*</span>
                                      </span>
                                      <Select
                                        showSearch
                                        className="drill-select"
                                        style={{ width: "100%" }}
                                        placeholder={col.reportId ? "Select field..." : "Select a report first"}
                                        optionFilterProp="children"
                                        disabled={!col.reportId}
                                        value={col.targetField}
                                        onChange={(val) => this.updateCellColumn(col.id, { targetField: val })}
                                        notFoundContent="This report has no saved columns"
                                      >
                                        {this.getFieldsForReport(col.reportId).map((f) => (
                                          <Select.Option key={f.fieldName} value={f.fieldName}>
                                            {f.label}
                                          </Select.Option>
                                        ))}
                                      </Select>
                                    </div>

                                    <div className="cell-action-info">
                                      <div className="external-info-icon">i</div>
                                      <span>
                                        Clicking a value in <b>{col.column || "the selected column"}</b> opens this
                                        report where <b>{col.targetField || "the matching field"}</b> equals the clicked
                                        value.
                                      </span>
                                    </div>
                                  </div>
                                ) : (
                                  this.renderExternalConfig({
                                    serviceUrl: col.serviceUrl,
                                    urlParamMap: col.urlParamMap,
                                    onChangeUrl: (url) => this.onChangeCellServiceUrl(col.id, url),
                                    onSetParamField: (name, field) => this.setCellUrlParamField(col.id, name, field),
                                  })
                                )}
                              </div>
                            ))}

                            {/* each entry is one link, so this adds another column -> report link */}
                            <button className="drill-mapping-add" onClick={this.addCellColumn}>
                              + Add Column
                            </button>

                            {/* ── COLUMN MAPPING (commented out — renderColumnMapping is
                                disabled below; leaving the call live threw
                                "this.renderColumnMapping is not a function") ── */}
                            {/* {this.renderColumnMapping()} */}
                          </div>
                        ) : null}

                        {/* ROW CLICK CONFIGURATION - same shape as the cell config,
                            minus picking a value: a row cannot be singled out, so the
                            action applies to every row. */}
                        {dd.triggerType === "row" ? (
                          <div className="cell-config">
                            <div className="cell-config-title">Row Click Configuration</div>
                            {this.renderTargetConfig()}
                          </div>
                        ) : null}
                      </Panel>

                      {/* ── NAVIGATION TYPE ──
                          Nested inside Drill Down: it only decides how a drill-down
                          opens, so it has nothing to say on its own. Collapsing Drill
                          Down now takes it (and the Apply/Reset buttons) with it. */}
                      <Panel header="Navigation Type" key="navigation-type">
                        <div className="nav-type-body">
                          <div className="nav-type-options">
                            <label className="nav-type-radio-row">
                              <input
                                type="radio"
                                name="navigationType"
                                value="_blank"
                                checked={dd.navigationType === "_blank"}
                                onChange={() => this.patchDrillDown({ navigationType: "_blank" })}
                              />
                              <span>New Tab</span>
                            </label>
                            <label className="nav-type-radio-row">
                              <input
                                type="radio"
                                name="navigationType"
                                value="modal"
                                checked={dd.navigationType === "modal"}
                                disabled={dd.targetType === "external"}
                                onChange={() => this.patchDrillDown({ navigationType: "modal" })}
                              />
                              <span>Modal</span>
                            </label>
                            <label className="nav-type-radio-row">
                              <input
                                type="radio"
                                name="navigationType"
                                value="side-panel"
                                checked={dd.navigationType === "side-panel"}
                                disabled={dd.targetType === "external"}
                                onChange={() => this.patchDrillDown({ navigationType: "side-panel" })}
                              />
                              <span>Side Panel</span>
                            </label>
                            <label className="nav-type-radio-row">
                              <input
                                type="radio"
                                name="navigationType"
                                value="_self"
                                checked={dd.navigationType === "_self"}
                                onChange={() => this.patchDrillDown({ navigationType: "_self" })}
                              />
                              <span>Same Tab</span>
                            </label>
                          </div>

                          {dd.targetType === "external" ? (
                            <div className="nav-type-note">
                              Modal and Side Panel can only show a report. An external service always opens in a tab.
                            </div>
                          ) : null}
                        </div>
                      </Panel>
                    </Collapse>

                    {/* These act on the drill-down only, so they live inside its panel.
                        The second button has two identities:
                          unsaved edits + something applied -> Cancel, back to the last
                              applied configuration (Apply is the commit point)
                          otherwise -> Reset, wipes the drill-down for this widget. On a
                              widget with nothing applied there is nothing to go back to,
                              so clearing the draft IS the reset.
                        Reset asks first, since it clears everything at once, and is
                        disabled when there is neither a draft nor an applied config. */}
                    {this.renderDrillDownActions()}
                  </Panel>
                </Collapse>
              )}

              {this.state.rightSidebarTab === "insert" && (
                <div className="insert-widget-panel">
                  <p className="chart-types-title">Chart Types</p>

                  {/* Say why the tiles are inert, rather than letting the drag just fail */}
                  {!this.canAddWidget() ? (
                    <div className="insert-limit-note">
                      A report holds one widget. Remove the current one to add a different widget.
                    </div>
                  ) : null}

                  <div className="chart-types-grid">
                    {[
                      { key: "table", label: "Table", icon: <TableOutlined /> },
                      /* Labelled for what it DRAWS. Every "pie" in this app renders as a
                         donut - buildDonutChartOptions, with the total in the middle -
                         so the tile said one thing and the canvas showed another. The
                         key stays "pie": it is the saved chartType on every existing
                         board, and renaming it would orphan them. */
                      { key: "pie", label: "Donut Chart", icon: <PieChartOutlined /> },
                      { key: "bar", label: "Bar Chart", icon: <BarChartOutlined /> },
                      { key: "line", label: "Line Chart", icon: <LineChartOutlined /> },
                    ].map(({ key, label, icon }) => {
                      const isActive =
                        key === "table"
                          ? this.state.activeWidgetName === "table" // table tile
                          : this.state.activeChartType === key.charAt(0).toUpperCase() + key.slice(1); // "pie"->"Pie" etc

                      return (
                        <div
                          key={key}
                          className={`chart-type-item${isActive ? " chart-type-item--active" : ""}${
                            this.canAddWidget() ? "" : " chart-type-item--disabled"
                          }`}
                          onClick={() => this.handleSelectedWidgetNameChange(key)}
                          draggable={this.canAddWidget()}
                          onDragStart={(e) => this.onDragStart(e, key)}
                          onDragEnd={this.onDragEndTile}
                        >
                          <div className="chart-type-icon">{icon}</div>
                          <span className="chart-type-label">{label}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* BOTTOM RESOURCE EDITOR — still here for now, will move in Step 2 */}
          {/* <div className="editor-resource-area">
            <ResourceEditor splitPosition={this.state.splitPosition} activeWidgetName={this.state.activeWidgetName} />
          </div> */}
        </div>

        {/* ── PREVIEW DRAWER (unchanged) ── */}
        <Drawer
          title={
            <>
              <Row>
                <Col span={24}>
                  <div style={{ margin: "auto", textAlign: "center", padding: "12px" }}>
                    <Space size="large">
                      {this.state.autorefresh ? (
                        <Button
                          type="link"
                          onClick={(e) => this.handleBannerChange(e, "refresh")}
                          icon={<MaterialDesignIcon icon="refresh" styles={{ fontSize: "24px" }} />}
                        />
                      ) : null}
                      {this.state.fullscreen ? (
                        <Button
                          type="link"
                          onClick={(e) => this.handleBannerChange(e, "autorun")}
                          icon={<MaterialDesignIcon icon="directions_run" styles={{ fontSize: "24px" }} />}
                        />
                      ) : null}
                      {this.state.csvdownload ? (
                        <Button
                          type="link"
                          onClick={(e) => this.handleBannerChange(e, "export")}
                          icon={<MaterialDesignIcon icon="import_export" styles={{ fontSize: "24px" }} />}
                        />
                      ) : null}
                      {this.state.refresh ? (
                        <Button
                          type="link"
                          onClick={() => window.location.reload(false)}
                          icon={<MaterialDesignIcon icon="reply" styles={{ fontSize: "24px" }} />}
                        />
                      ) : null}
                      {this.state.fullscreen ? (
                        <Button
                          type="link"
                          onClick={(e) => this.handleBannerChange(e, "fullscreen")}
                          icon={<MaterialDesignIcon icon="fullscreen" styles={{ fontSize: "24px" }} />}
                        />
                      ) : null}
                    </Space>
                  </div>
                </Col>
              </Row>
              <Row>
                {/* Placeholder text only - a filter bar was never built here, and the
                    "Display filters" toggle that drove it is commented out above. */}
                {/* <Col span={24}>{this.state.filters ? <>Filter section</> : null}</Col> */}
              </Row>
            </>
          }
          placement="top"
          height="100%"
          closable={true}
          onClose={this.onClose}
          visible={visible}
          key="top"
        >
          <div className="PreviewLayout">
            <ResponsiveReactGridLayout
              layout={this.state.layout}
              onLayoutChange={this.onLayoutChange}
              {...this.props}
              onDrop={this.onDrop}
              droppingItem={this.props.item}
              measureBeforeMount={false}
              useCSSTransforms={this.state.mounted}
              compactType={this.state.compactType}
              preventCollision={true}
              isDroppable={this.canAddWidget()}
            >
              {_.map(this.state.layouts.lg, (el) => this.generateDOM(el))}
            </ResponsiveReactGridLayout>
          </div>
        </Drawer>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { editor, user, boards } = state;

  return {
    // saved boards - used as drill-down target reports
    boardsData: boards?.boardsData || [],
    selectedResource: editor.selectedResource,
    // reportData: editor.selectedResource.reportData,
    // currentSource: editor.selectedResource.source,
    resourceList: editor.resourceList,
    dashboardConfig: editor.dashboardConfig,
    boardSavingState: editor.boardSavingState,
    boardPublishState: editor.boardPublishState,
    savedBoardId: editor.savedBoardId ? editor.savedBoardId : null,
    currentAppPermissions: user.currentAppPermissions ? user.currentAppPermissions : [],
    lastDeletedResourceID: editor.deletedResourceID,
    addedResourceId: editor.addedResourceId,
    properties: editor.properties,
    isLoadingDashboard: editor.isLoadingDashboard,
    dashboardLoadError: editor.dashboardLoadError,
    isRefreshing: editor.isRefreshing,
  };
};
const mapDispatchToProps = (dispatch) => ({
  saveDashboardInfo: (data) => dispatch(saveDashboardAsync(data)),
  publishDashboard: (data) => dispatch(publishDashboardAsync(data)),
  updateWidjetPositions: (layout) => dispatch(updateComponentPositions({ layout: layout })),
  setDashboardConfig: (details) => dispatch(addDashboardConfig(details)),
  resetEditor: () => dispatch(resetEditor()),
  resetAllEditorData: () => dispatch(resetAllEditorData()),
  logOut: () => dispatch(signout()),
  resetBoardSavingState: () => dispatch(resetBoardSavingState()),
  resetBoardPublishState: () => dispatch(resetBoardPublishState()),
  updateSelectedWidjetName: (data) => dispatch(updateSelectedWidjet(data)),
  // renaming a widget from its card header on a dashboard
  updateWidgetName: (data) => dispatch(updateSelectedResourceWidgetName(data)),
  // clicking a widget on the canvas points every config panel at that widget's resource
  selectResource: (data) => dispatch(updateSelectedResource(data)),
  // per-widget display properties (download / full screen) — dashboards only
  setResourceProperty: (data) => dispatch(updateResourceProperties(data)),
  // clears one resource's chart config when its chart widget is deleted
  resetChartConfigForResource: (data) => dispatch(resetChartConfig(data)),
  resetResourceRemoveState: () => dispatch(resetResourceRemoveState()),
  resetResourceAddStatus: () => dispatch(resetResourceAddStatus()),
  getDashboardDetailsAsync: (data) => dispatch(getDashboardDetailsAsync(data)),
  updateDashboardName: (data) => dispatch(updateDashboardName(data)),
  getBoardsAsync: () => dispatch(getBoardsAsync()),
  handleUpdateSelectedFields: (data) => dispatch(updateSelectedFields(data)),
  handleReOrderFields: (data) => dispatch(reOrderFields(data)),
  resetChartConfig: () => dispatch(resetChartConfig()),
  fetchAllResourceData: () => dispatch(fetchAllResourceDataAsync()),
  // writes drill-down config onto the selected resource, same channel HyperLink used
  saveDrillDowns: (data) => dispatch(updateDrillDowns(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ResizableHandles));
